/* Import libraries */
import React from "react";
import { Motion, spring } from "react-motion";

/* Import CSS */
import styles from "./css/Icon.css";

const Icon = props => {
  const { icon, size, color, shadow, state, ...rest } = props;
  let style = styles[`icon_${icon}`];

  if (size && !color) {
    style = styles[`icon_${icon}_${size}`];
  }

  if (!size && color) {
    style = styles[`icon_${icon}_${color}`];
  }

  if (size && color) {
    style = styles[`icon_${icon}_${size}_${color}`];
  }

  if (shadow) {
    style = styles[`icon_${icon}_shadow`];
  }

  if (icon === "check_checked") {
    return (
      <svg
        className={styles.icon_check_checked}
        viewBox="0 0 400 400"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title"
      >
        <g>
          <title>Completed</title>
          <ellipse
            stroke="#000"
            ry="198.999999"
            rx="198.999999"
            id="svg_1"
            cy="200.500001"
            cx="200.547621"
            strokeWidth="0"
            fill="#1baff3"
          />
          <line
            strokeWidth="34"
            strokeLinecap="null"
            strokeLinejoin="null"
            id="svg_2"
            y2="105.5"
            x2="334.54762"
            y1="302.5"
            x1="150.54762"
            stroke="#ffffff"
            fill="none"
          />
          <line
            stroke="#ffffff"
            strokeLinecap="null"
            strokeLinejoin="null"
            id="svg_3"
            y2="207.565217"
            x2="76.433136"
            y1="303.434781"
            x1="172.662104"
            strokeWidth="34"
            fill="none"
          />
        </g>
      </svg>
    );
  }

  if (icon === "check_unchecked") {
    return (
      <svg
        className={styles.icon_check_unchecked}
        viewBox="0 0 400 400"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title"
      >
        <g>
          <title>Incomplete</title>
          <ellipse
            stroke="#000"
            ry="198.999999"
            rx="198.999999"
            id="svg_1"
            cy="200.500001"
            cx="200.547621"
            strokeWidth="0"
            fill="#c9c9c9"
          />
        </g>
      </svg>
    );
  }

  if (icon === "home" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27.32 25.01"
      >
        <path
          d="M28,33H22a1,1,0,0,1-1-1V24H18v8a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V22H7.35a1,1,0,0,1-.69-1.73l12.72-12a1,1,0,0,1,1.38,0l12.59,12a1,1,0,0,1-.7,1.73H29V32A1,1,0,0,1,28,33Zm-5-2h4V21a1,1,0,0,1,1-1h2.16l-10.1-9.65L9.86,20H11a1,1,0,0,1,1,1V31h4V23a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1Z"
          transform="translate(-6.34 -7.99)"
        />
      </svg>
    );
  }

  if (icon === "home" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 27.32 25.01"
        >
          <path
            d="M28,33H22a1,1,0,0,1-1-1V24H18v8a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V22H7.35a1,1,0,0,1-.69-1.73l12.72-12a1,1,0,0,1,1.38,0l12.59,12a1,1,0,0,1-.7,1.73H29V32A1,1,0,0,1,28,33Zm-5-2h4V21a1,1,0,0,1,1-1h2.16l-10.1-9.65L9.86,20H11a1,1,0,0,1,1,1V31h4V23a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1Z"
            transform="translate(-6.34 -7.99)"
          />
        </svg>
      </div>
    );
  }

  if (icon === "help") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="14"
        viewBox="0 0 9 14"
      >
        <text data-name="?" x="4.248" y="13.24">
          <tspan x="4.248">?</tspan>
        </text>
      </svg>
    );
  }

  if (icon === "stop") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <path d="M21.5,28.9L10.8,29l-7.7-7.5L3,10.8l7.5-7.7L21.2,3l7.7,7.5L29,21.2L21.5,28.9z" />
      </svg>
    );
  }

  if (icon === "profile") {
    return (
      <svg
        className={style}
        viewBox="0 0 27.2 26.3"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0"
          className={styles.icon_profile_rect}
          width="57.6"
          height="55.8"
        />
        <g>
          <path d="M13.3,1.2c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C25.3,6.6,19.9,1.2,13.3,1.2z M9,22.8v-4.6c0-2.4,1.9-4.3,4.3-4.3c2.3,0,4.3,2,4.3,4.3v4.6c-1.3,0.6-2.8,0.9-4.3,0.9C11.7,23.7,10.3,23.4,9,22.8z M19.1,22v-3.8c0-3.2-2.7-5.8-5.8-5.8c-3.2,0-5.8,2.6-5.8,5.8V22c-2.8-1.9-4.7-5.1-4.7-8.8c0-5.8,4.7-10.5,10.5-10.5c5.8,0,10.5,4.7,10.5,10.5C23.8,16.9,21.9,20.1,19.1,22z" />
          <path d="M13.3,4.3c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6S15.3,4.3,13.3,4.3z M13.3,10c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1S14.4,10,13.3,10z" />
        </g>
      </svg>
    );
  }

  if (icon === "addons") {
    return (
      <svg
        className={style}
        width="26px"
        height="32px"
        viewBox="0 0 26 26"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          transform="translate(-10.000000, -10.000000)"
          strokeWidth="1.5"
          stroke="var(--main-font-color)"
          fill="none"
        >
          <g transform="translate(11.000000, 11.000000)">
            <path
              d="M2.479,18 C3.457,18 3.788,17.476 4.187,17.078 C5,16.262 6,16.609 6,17.925 L6,24 L12.075,24 C13.39,24 13.738,23 12.922,22.187 C12.524,21.788 12,21.457 12,20.479 C12,19.392 13.108,18 15,18 C16.892,18 18,19.392 18,20.479 C18,21.457 17.476,21.788 17.078,22.187 C16.262,23 16.609,24 17.925,24 L24,24 L24,17.925 C24,16.61 23,16.262 22.187,17.078 C21.788,17.476 21.457,18 20.479,18 C19.392,18 18,16.892 18,15 C18,13.108 19.392,12 20.479,12 C21.457,12 21.788,12.524 22.187,12.922 C23,13.738 24,13.391 24,12.075 L24,6 L17.925,6 C16.61,6 16.262,5 17.078,4.187 C17.476,3.788 18,3.457 18,2.479 C18,1.392 16.892,8.8817842e-16 15,8.8817842e-16 C13.108,8.8817842e-16 12,1.392 12,2.479 C12,3.457 12.524,3.788 12.922,4.187 C13.738,5 13.391,6 12.075,6 L6,6 L6,12.075 C6,13.39 5,13.738 4.187,12.922 C3.788,12.524 3.457,12 2.479,12 C1.392,12 8.8817842e-16,13.108 8.8817842e-16,15 C8.8817842e-16,16.892 1.392,18 2.479,18 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "lead" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 80.2 101.7"
      >
        <g strokeWidth="3" stroke="var(--main-font-color)">
          <path
            d="M69.3,98.6H10.7c-4.2,0.1-7.7-3.3-7.8-7.5v-80c0.1-4.2,3.6-7.6,7.8-7.5h58.6c4.2-0.1,7.7,3.3,7.8,7.5v80.1
              C76.9,95.3,73.5,98.7,69.3,98.6z M10.7,7.6c-2-0.1-3.7,1.5-3.8,3.5v80c0.1,2,1.8,3.6,3.8,3.5h58.6c2,0.1,3.7-1.5,3.8-3.5V11
              c-0.1-2-1.8-3.5-3.8-3.5H10.7z M64.9,19.6c0-1.1-0.9-2-2-2H30c-1.1,0-2,0.9-2,2s0.9,2,2,2h32.9C64,21.6,64.9,20.7,64.9,19.6z
              M64.9,29.7c0-1.1-0.9-2-2-2H17c-1.1,0-2,0.9-2,2s0.9,2,2,2h45.9C64,31.7,64.9,30.8,64.9,29.7z M24,19.6c0-1.1-0.9-2-2-2H17
              c-1.1,0-2,0.9-2,2s0.9,2,2,2H22C23.1,21.6,24,20.7,24,19.6L24,19.6z M55.4,73.5c-0.5-1-1.7-1.4-2.7-0.9c-8,4.1-17.4,4.1-25.4,0
              c-1-0.5-2.1-0.1-2.6,0.8c-0.5,1-0.2,2.2,0.8,2.7c9.1,4.6,19.9,4.6,29,0C55.5,75.7,55.9,74.5,55.4,73.5L55.4,73.5z M36.4,48.1
              c-1.7-3.4-5.7-5.5-10.6-5.5s-8.9,2.1-10.6,5.5c-0.5,1-0.1,2.2,0.9,2.7s2.2,0.1,2.7-0.9c1-2,3.8-3.3,7-3.3s6,1.3,7,3.3
              c0.5,1,1.7,1.4,2.7,0.9S36.9,49.1,36.4,48.1L36.4,48.1z M64.2,48.1c-1.7-3.4-5.7-5.5-10.6-5.5s-8.9,2.1-10.6,5.5
              c-0.5,1-0.1,2.2,0.9,2.7s2.2,0.1,2.7-0.9c1-2,3.8-3.3,7-3.3s6,1.3,7,3.3c0.5,1,1.7,1.4,2.7,0.9C64.3,50.3,64.7,49.1,64.2,48.1
              L64.2,48.1z"
          />
        </g>
      </svg>
    );
  }

  if (icon === "lead" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 80.2 101.7"
        >
          <g strokeWidth="3" stroke="var(--main-font-color)">
            <path
              d="M69.3,98.6H10.7c-4.2,0.1-7.7-3.3-7.8-7.5v-80c0.1-4.2,3.6-7.6,7.8-7.5h58.6c4.2-0.1,7.7,3.3,7.8,7.5v80.1
                C76.9,95.3,73.5,98.7,69.3,98.6z M10.7,7.6c-2-0.1-3.7,1.5-3.8,3.5v80c0.1,2,1.8,3.6,3.8,3.5h58.6c2,0.1,3.7-1.5,3.8-3.5V11
                c-0.1-2-1.8-3.5-3.8-3.5H10.7z M64.9,19.6c0-1.1-0.9-2-2-2H30c-1.1,0-2,0.9-2,2s0.9,2,2,2h32.9C64,21.6,64.9,20.7,64.9,19.6z
                M64.9,29.7c0-1.1-0.9-2-2-2H17c-1.1,0-2,0.9-2,2s0.9,2,2,2h45.9C64,31.7,64.9,30.8,64.9,29.7z M24,19.6c0-1.1-0.9-2-2-2H17
                c-1.1,0-2,0.9-2,2s0.9,2,2,2H22C23.1,21.6,24,20.7,24,19.6L24,19.6z M55.4,73.5c-0.5-1-1.7-1.4-2.7-0.9c-8,4.1-17.4,4.1-25.4,0
                c-1-0.5-2.1-0.1-2.6,0.8c-0.5,1-0.2,2.2,0.8,2.7c9.1,4.6,19.9,4.6,29,0C55.5,75.7,55.9,74.5,55.4,73.5L55.4,73.5z M36.4,48.1
                c-1.7-3.4-5.7-5.5-10.6-5.5s-8.9,2.1-10.6,5.5c-0.5,1-0.1,2.2,0.9,2.7s2.2,0.1,2.7-0.9c1-2,3.8-3.3,7-3.3s6,1.3,7,3.3
                c0.5,1,1.7,1.4,2.7,0.9S36.9,49.1,36.4,48.1L36.4,48.1z M64.2,48.1c-1.7-3.4-5.7-5.5-10.6-5.5s-8.9,2.1-10.6,5.5
                c-0.5,1-0.1,2.2,0.9,2.7s2.2,0.1,2.7-0.9c1-2,3.8-3.3,7-3.3s6,1.3,7,3.3c0.5,1,1.7,1.4,2.7,0.9C64.3,50.3,64.7,49.1,64.2,48.1
                L64.2,48.1z"
            />
          </g>
        </svg>
      </div>
    );
  }

  if (icon === "application" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19.84 23.82"
      >
        <path
          d="M29.92,27a4.88,4.88,0,0,1-4.85,4.91H15a4.88,4.88,0,0,1-4.92-4.84s0,0,0-.07V13a4.88,4.88,0,0,1,4.85-4.91H25a4.88,4.88,0,0,1,4.92,4.84s0,0,0,.07ZM28.34,13a3.29,3.29,0,0,0-3.26-3.32H15a3.29,3.29,0,0,0-3.34,3.24s0,.05,0,.08V27a3.29,3.29,0,0,0,3.26,3.32H25a3.29,3.29,0,0,0,3.34-3.24s0-.05,0-.08Z"
          transform="translate(-10.08 -8.09)"
        />
        <rect x="3.97" y="5.16" width="11.91" height="1.59" />
        <rect x="3.97" y="9.13" width="11.91" height="1.59" />
        <rect x="3.97" y="13.1" width="11.91" height="1.59" />
        <rect x="3.97" y="17.07" width="11.91" height="1.59" />
      </svg>
    );
  }

  if (icon === "application" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19.84 23.82"
        >
          <path
            d="M29.92,27a4.88,4.88,0,0,1-4.85,4.91H15a4.88,4.88,0,0,1-4.92-4.84s0,0,0-.07V13a4.88,4.88,0,0,1,4.85-4.91H25a4.88,4.88,0,0,1,4.92,4.84s0,0,0,.07ZM28.34,13a3.29,3.29,0,0,0-3.26-3.32H15a3.29,3.29,0,0,0-3.34,3.24s0,.05,0,.08V27a3.29,3.29,0,0,0,3.26,3.32H25a3.29,3.29,0,0,0,3.34-3.24s0-.05,0-.08Z"
            transform="translate(-10.08 -8.09)"
          />
          <rect x="3.97" y="5.16" width="11.91" height="1.59" />
          <rect x="3.97" y="9.13" width="11.91" height="1.59" />
          <rect x="3.97" y="13.1" width="11.91" height="1.59" />
          <rect x="3.97" y="17.07" width="11.91" height="1.59" />
        </svg>
      </div>
    );
  }

  if (icon === "connection" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 34.06 23.31"
      >
        <path
          d="M36.23,24.52H31.65V22.09C31.65,19,29.36,16,26.31,16S21,19,21,22.09v2.43H18.91V22.09c0-3.14-2.5-6.14-5.55-6.14s-5.55,3-5.55,6.14v2.43h-4a.82.82,0,0,0,0,1.64h4v5.5h11.1v-5.5H36.23a.82.82,0,0,0,0-1.64ZM22.61,22.09c0-2.35,1.67-4.5,3.7-4.5s3.7,2.14,3.7,4.5v2.43h-7.4Z"
          transform="translate(-2.99 -8.35)"
        />
        <path
          d="M26.58,14.51a3.08,3.08,0,1,0-3.08-3.08h0A3.08,3.08,0,0,0,26.58,14.51Zm0-4.52a1.44,1.44,0,1,1-1.44,1.44A1.44,1.44,0,0,1,26.58,10Z"
          transform="translate(-2.99 -8.35)"
        />
        <circle cx="10.43" cy="3.08" r="3.08" />
      </svg>
    );
  }

  if (icon === "connection" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 34.06 23.31"
        >
          <path
            d="M36.23,24.52H31.65V22.09C31.65,19,29.36,16,26.31,16S21,19,21,22.09v2.43H18.91V22.09c0-3.14-2.5-6.14-5.55-6.14s-5.55,3-5.55,6.14v2.43h-4a.82.82,0,0,0,0,1.64h4v5.5h11.1v-5.5H36.23a.82.82,0,0,0,0-1.64ZM22.61,22.09c0-2.35,1.67-4.5,3.7-4.5s3.7,2.14,3.7,4.5v2.43h-7.4Z"
            transform="translate(-2.99 -8.35)"
          />
          <path
            d="M26.58,14.51a3.08,3.08,0,1,0-3.08-3.08h0A3.08,3.08,0,0,0,26.58,14.51Zm0-4.52a1.44,1.44,0,1,1-1.44,1.44A1.44,1.44,0,0,1,26.58,10Z"
            transform="translate(-2.99 -8.35)"
          />
          <circle cx="10.43" cy="3.08" r="3.08" />
        </svg>
      </div>
    );
  }

  if (icon === "reporting" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 22"
      >
        <path d="M23,22H1a1,1,0,0,1-1-1V1A1,1,0,0,1,2,1V20H23a1,1,0,0,1,0,2Zm-8.39-6,8.61-8.61a1,1,0,1,0-1.3-1.52L21.81,6,13.9,13.84,10,10a1,1,0,0,0-1.41,0l-4.5,4.5A1,1,0,0,0,5.5,15.91l3.79-3.79L13.2,16A1,1,0,0,0,14.61,16Z" />
      </svg>
    );
  }

  if (icon === "reporting" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 22"
        >
          <path d="M23,22H1a1,1,0,0,1-1-1V1A1,1,0,0,1,2,1V20H23a1,1,0,0,1,0,2Zm-8.39-6,8.61-8.61a1,1,0,1,0-1.3-1.52L21.81,6,13.9,13.84,10,10a1,1,0,0,0-1.41,0l-4.5,4.5A1,1,0,0,0,5.5,15.91l3.79-3.79L13.2,16A1,1,0,0,0,14.61,16Z" />
        </svg>
      </div>
    );
  }

  if (icon === "setting" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25.88 25.84"
      >
        <path
          d="M22.07,34.11H17.93a.65.65,0,0,1-.65-.65h0V30.4a9.44,9.44,0,0,1-1.86-.79l-2.18,2.18a.65.65,0,0,1-.92,0h0L9.4,28.87a.65.65,0,0,1,0-.92h0l2.22-2.22A9.43,9.43,0,0,1,10.91,24H7.73a.65.65,0,0,1-.65-.65v-4.2a.65.65,0,0,1,.65-.65h3.22a9.5,9.5,0,0,1,.71-1.69l-2.3-2.3a.65.65,0,0,1,0-.92h0l3-3a.65.65,0,0,1,.92,0h0l2.3,2.3a9.45,9.45,0,0,1,1.73-.72V8.92A.65.65,0,0,1,18,8.27H22.1a.65.65,0,0,1,.65.65v3.22a9.46,9.46,0,0,1,1.77.72l2.27-2.27a.65.65,0,0,1,.92,0h0l2.93,2.93a.65.65,0,0,1,0,.92h0l-2.22,2.22a9.47,9.47,0,0,1,.77,1.81h3.12a.65.65,0,0,1,.65.65h0v4.2a.65.65,0,0,1-.65.65H29.19a9.43,9.43,0,0,1-.75,1.81l2.16,2.16a.65.65,0,0,1,0,.92h0l-3,3a.65.65,0,0,1-.92,0h0L24.52,29.7a9.47,9.47,0,0,1-1.83.75v3A.65.65,0,0,1,22.07,34.11Zm-3.42-1.84h2.7V29.52a.63.63,0,0,1,.5-.61A7.79,7.79,0,0,0,24.11,28a.63.63,0,0,1,.78.08l2,2,2-2-2-2a.63.63,0,0,1-.08-.78,7.77,7.77,0,0,0,.92-2.24.63.63,0,0,1,.61-.5h2.8V19.84H28.25a.63.63,0,0,1-.61-.49,7.79,7.79,0,0,0-1-2.23.63.63,0,0,1,.08-.79l2-2L26.88,12.4l-2,2.06a.63.63,0,0,1-.78.08,7.77,7.77,0,0,0-2.2-.89.63.63,0,0,1-.5-.61V10.11h-2.7v3a.63.63,0,0,1-.49.61,7.78,7.78,0,0,0-2.17.9.63.63,0,0,1-.78-.08L13.12,12.4l-2,2,2.09,2.09a.63.63,0,0,1,.08.78,7.81,7.81,0,0,0-.89,2.13.63.63,0,0,1-.61.49H8.92V22.6H11.8a.63.63,0,0,1,.61.5,7.78,7.78,0,0,0,.89,2.19.63.63,0,0,1-.08.78l-2,2L13.12,30l2-2a.63.63,0,0,1,.79-.08,7.77,7.77,0,0,0,2.27,1,.63.63,0,0,1,.49.61Z"
          transform="translate(-7.08 -8.27)"
        />
        <path
          d="M21.21,25.49A4.47,4.47,0,0,1,15.7,20a4.4,4.4,0,0,1,3.09-3.09A4.47,4.47,0,0,1,24.3,22.4,4.4,4.4,0,0,1,21.21,25.49Zm-.65-7.13a2.88,2.88,0,1,0,2.26,2.26A2.88,2.88,0,0,0,20.56,18.36Z"
          transform="translate(-7.08 -8.27)"
        />
      </svg>
    );
  }

  if (icon === "setting" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 25.88 25.84"
        >
          <path
            d="M22.07,34.11H17.93a.65.65,0,0,1-.65-.65h0V30.4a9.44,9.44,0,0,1-1.86-.79l-2.18,2.18a.65.65,0,0,1-.92,0h0L9.4,28.87a.65.65,0,0,1,0-.92h0l2.22-2.22A9.43,9.43,0,0,1,10.91,24H7.73a.65.65,0,0,1-.65-.65v-4.2a.65.65,0,0,1,.65-.65h3.22a9.5,9.5,0,0,1,.71-1.69l-2.3-2.3a.65.65,0,0,1,0-.92h0l3-3a.65.65,0,0,1,.92,0h0l2.3,2.3a9.45,9.45,0,0,1,1.73-.72V8.92A.65.65,0,0,1,18,8.27H22.1a.65.65,0,0,1,.65.65v3.22a9.46,9.46,0,0,1,1.77.72l2.27-2.27a.65.65,0,0,1,.92,0h0l2.93,2.93a.65.65,0,0,1,0,.92h0l-2.22,2.22a9.47,9.47,0,0,1,.77,1.81h3.12a.65.65,0,0,1,.65.65h0v4.2a.65.65,0,0,1-.65.65H29.19a9.43,9.43,0,0,1-.75,1.81l2.16,2.16a.65.65,0,0,1,0,.92h0l-3,3a.65.65,0,0,1-.92,0h0L24.52,29.7a9.47,9.47,0,0,1-1.83.75v3A.65.65,0,0,1,22.07,34.11Zm-3.42-1.84h2.7V29.52a.63.63,0,0,1,.5-.61A7.79,7.79,0,0,0,24.11,28a.63.63,0,0,1,.78.08l2,2,2-2-2-2a.63.63,0,0,1-.08-.78,7.77,7.77,0,0,0,.92-2.24.63.63,0,0,1,.61-.5h2.8V19.84H28.25a.63.63,0,0,1-.61-.49,7.79,7.79,0,0,0-1-2.23.63.63,0,0,1,.08-.79l2-2L26.88,12.4l-2,2.06a.63.63,0,0,1-.78.08,7.77,7.77,0,0,0-2.2-.89.63.63,0,0,1-.5-.61V10.11h-2.7v3a.63.63,0,0,1-.49.61,7.78,7.78,0,0,0-2.17.9.63.63,0,0,1-.78-.08L13.12,12.4l-2,2,2.09,2.09a.63.63,0,0,1,.08.78,7.81,7.81,0,0,0-.89,2.13.63.63,0,0,1-.61.49H8.92V22.6H11.8a.63.63,0,0,1,.61.5,7.78,7.78,0,0,0,.89,2.19.63.63,0,0,1-.08.78l-2,2L13.12,30l2-2a.63.63,0,0,1,.79-.08,7.77,7.77,0,0,0,2.27,1,.63.63,0,0,1,.49.61Z"
            transform="translate(-7.08 -8.27)"
          />
          <path
            d="M21.21,25.49A4.47,4.47,0,0,1,15.7,20a4.4,4.4,0,0,1,3.09-3.09A4.47,4.47,0,0,1,24.3,22.4,4.4,4.4,0,0,1,21.21,25.49Zm-.65-7.13a2.88,2.88,0,1,0,2.26,2.26A2.88,2.88,0,0,0,20.56,18.36Z"
            transform="translate(-7.08 -8.27)"
          />
        </svg>
      </div>
    );
  }

  if (icon === "entity_x1") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50.3 80.72"
      >
        <g>
          <path
            d="M198.07,179.65A12.89,12.89,0,1,1,211,166.76a12.89,12.89,0,0,1-12.93,12.89Zm0-21.79a8.89,8.89,0,1,0,8.89,8.89h0a8.9,8.9,0,0,0-8.89-8.88Z"
            transform="translate(-172.89 -153.87)"
          />
          <path
            d="M218,234.59h-3.66a5.11,5.11,0,0,1-5.18-5v-28.7a2,2,0,0,1,4,0v28.7a1.14,1.14,0,0,0,1.18,1H218a1.14,1.14,0,0,0,1.18-1v-27.2c0-9.2-4.42-13.51-14.77-14.38H192c-13.35.93-15.16,7.81-15.16,14.41v27.17a1.14,1.14,0,0,0,1.18,1h4.45a1.14,1.14,0,0,0,1.18-1v-28.7a2,2,0,1,1,4,0v28.7a5.11,5.11,0,0,1-5.18,5h-4.45a5.11,5.11,0,0,1-5.18-5v-27.2c0-11.52,6.2-17.54,19-18.41h12.78c12.46,1,18.52,7,18.52,18.37v27.17a5.11,5.11,0,0,1-5.15,5.07Z"
            transform="translate(-172.89 -153.87)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "entity_x2") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 75.5 68.03"
      >
        <g>
          <path
            d="M181.21,181.85A10.81,10.81,0,1,1,192,171a10.81,10.81,0,0,1-10.79,10.85h0Zm0-17.62a6.81,6.81,0,1,0,6.79,6.83s0,0,0-.06a6.82,6.82,0,0,0-6.79-6.77h0Z"
            transform="translate(-160.3 -160.23)"
          />
          <path
            d="M212.21,181.85A10.81,10.81,0,1,1,223,171a10.81,10.81,0,0,1-10.79,10.85h0Zm0-17.62a6.81,6.81,0,1,0,6.79,6.83s0,0,0-.06a6.82,6.82,0,0,0-6.79-6.77h0Z"
            transform="translate(-160.3 -160.23)"
          />
          <path
            d="M231.06,228.23h-3.17a4.69,4.69,0,0,1-4.76-4.62h0V199.07a2,2,0,0,1,4,0v24.54a0.72,0.72,0,0,0,.76.62h3.17a0.72,0.72,0,0,0,.76-0.62V200.39c0-7.79-3.75-11.44-12.54-12.18H208.6a20.48,20.48,0,0,0-7.37,1.65c2.13,2.61,3.19,6.12,3.19,10.56v23.22a4.69,4.69,0,0,1-4.76,4.62h-3.17a4.69,4.69,0,0,1-4.76-4.62h0V200.39c0-4.41,1-7.91,3.12-10.52a19.89,19.89,0,0,0-7-1.67H177.17c-9.14.64-12.87,4.18-12.87,12.21v23.22a0.72,0.72,0,0,0,.76.62h3.85a0.72,0.72,0,0,0,.76-0.62V199.07a2,2,0,0,1,4,0v24.54a4.69,4.69,0,0,1-4.76,4.62h-3.85a4.69,4.69,0,0,1-4.76-4.62h0V200.39c0-10.15,5.45-15.45,16.67-16.21H188.1A22.17,22.17,0,0,1,198,187a22.26,22.26,0,0,1,10.36-2.88h11.13c11,0.9,16.29,6.19,16.29,16.18v23.22a4.69,4.69,0,0,1-4.7,4.68h0Zm-33-35.95c-1.58,1.93-2.29,4.59-2.29,8.11v23.22a0.72,0.72,0,0,0,.76.62h3.17a0.72,0.72,0,0,0,.76-0.62V200.39c0-3.51-.81-6.17-2.46-8.11h0.06Z"
            transform="translate(-160.3 -160.23)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "entity_x3") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 106.81 68.05"
      >
        <g>
          <path
            d="M165.55,181.87a10.81,10.81,0,1,1,10.81-10.81h0A10.82,10.82,0,0,1,165.55,181.87Zm0-17.62a6.81,6.81,0,1,0,6.81,6.81h0A6.82,6.82,0,0,0,165.55,164.25Z"
            transform="translate(-144.63 -160.22)"
          />
          <path
            d="M196.77,181.87a10.81,10.81,0,1,1,10.81-10.81h0A10.82,10.82,0,0,1,196.77,181.87Zm0-17.62a6.81,6.81,0,1,0,6.81,6.81h0A6.82,6.82,0,0,0,196.77,164.25Z"
            transform="translate(-144.63 -160.22)"
          />
          <path
            d="M228.28,181.84A10.81,10.81,0,1,1,239.09,171a10.81,10.81,0,0,1-10.81,10.84h0Zm0-17.62a6.81,6.81,0,1,0,6.81,6.81h0A6.82,6.82,0,0,0,228.28,164.22Z"
            transform="translate(-144.63 -160.22)"
          />
          <path
            d="M215.22,228.24H212a4.69,4.69,0,0,1-4.76-4.62h0l0.1-23.26c0-4.38,1-7.85,3.07-10.45a19.79,19.79,0,0,0-7-1.69H192.73a20.77,20.77,0,0,0-7.24,1.59c2.17,2.62,3.24,6.15,3.24,10.62v23.22a4.69,4.69,0,0,1-4.76,4.62H180.8a4.69,4.69,0,0,1-4.76-4.62h0l-0.18-23.21c0-4.46,1-8,3.17-10.59a20.15,20.15,0,0,0-6.85-1.61H161.5c-9.14.64-12.87,4.18-12.87,12.21v23.22a0.72,0.72,0,0,0,.76.62h3.85a0.72,0.72,0,0,0,.76-0.62V199.09a2,2,0,0,1,4,0v24.54a4.69,4.69,0,0,1-4.76,4.62h-3.85a4.69,4.69,0,0,1-4.76-4.62h0V200.4c0-10.15,5.45-15.45,16.67-16.21h11.13a22.29,22.29,0,0,1,9.83,2.8,22.38,22.38,0,0,1,10.26-2.83h11.13a22.13,22.13,0,0,1,9.94,2.86A22.15,22.15,0,0,1,224,184.09h11.13c11,0.9,16.29,6.19,16.29,16.18v23.22a4.7,4.7,0,0,1-4.76,4.62h-3.17a4.7,4.7,0,0,1-4.76-4.62V199.05a2,2,0,1,1,4,0v24.54a0.72,0.72,0,0,0,.76.62h3.17a0.72,0.72,0,0,0,.76-0.62V200.37c0-7.79-3.75-11.44-12.54-12.19H224.22a20.3,20.3,0,0,0-7.46,1.7c2.13,2.61,3.18,6.12,3.18,10.55v23.22A4.69,4.69,0,0,1,215.22,228.24Zm-1.6-35.9c-1.53,1.92-2.23,4.56-2.23,8l-0.1,23.26a0.73,0.73,0,0,0,.76.61h3.17a0.72,0.72,0,0,0,.76-0.62V200.4C216,196.93,215.23,194.27,213.62,192.34Zm-31.35-.15c-1.64,1.94-2.38,4.63-2.38,8.22l0.18,23.21a0.72,0.72,0,0,0,.76.63H184a0.72,0.72,0,0,0,.76-0.62V200.4c0-3.56-.76-6.26-2.49-8.21h0Z"
            transform="translate(-144.63 -160.22)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "entity_x3plus") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 101.64 82.72"
      >
        <g>
          <path
            d="M167.3,186.87a10.4,10.4,0,1,1,10.4-10.4h0A10.41,10.41,0,0,1,167.3,186.87Zm0-16.8a6.4,6.4,0,1,0,6.4,6.4h0a6.41,6.41,0,0,0-6.4-6.4h0Z"
            transform="translate(-147.33 -152.87)"
          />
          <path
            d="M228.84,186.87a10.4,10.4,0,1,1,10.4-10.4h0A10.41,10.41,0,0,1,228.84,186.87Zm0-16.8a6.4,6.4,0,1,0,6.4,6.4h0a6.41,6.41,0,0,0-6.4-6.4h0Z"
            transform="translate(-147.33 -152.87)"
          />
          <path
            d="M197.93,178.65a12.89,12.89,0,1,1,12.89-12.89h0A12.91,12.91,0,0,1,197.93,178.65Zm0-21.79a8.89,8.89,0,1,0,8.89,8.89h0a8.9,8.9,0,0,0-8.89-8.88h0Z"
            transform="translate(-147.33 -152.87)"
          />
          <path
            d="M217.88,235.59h-3.66a5.11,5.11,0,0,1-5.18-5L208.62,204c0-6.51,2.48-11,7.4-13.47-2.38-2.64-6.21-4.08-11.73-4.54H191.93c-6.15.43-9.85,2.12-12.05,4.46,5.07,2.43,7.64,7,7.64,13.56l0.07,26.56a5.11,5.11,0,0,1-5.18,5H178a5.11,5.11,0,0,1-5.18-5V200.39a22.69,22.69,0,0,1,1.17-7.63q-1.08-.18-2.3-0.29h-8.18c-8.65.6-12.18,4-12.18,11.55v16.91a0.6,0.6,0,0,0,.63.5h3.67a0.6,0.6,0,0,0,.63-0.5V202.74a2,2,0,0,1,4,0v18.17a4.57,4.57,0,0,1-4.63,4.5H152a4.57,4.57,0,0,1-4.63-4.5V204c0-9.73,5.23-14.82,16-15.55H172a28.23,28.23,0,0,1,4,.59c3-4.23,8.29-6.57,15.88-7.09h12.81c7.37,0.61,12.5,3,15.46,7.12a27.84,27.84,0,0,1,4.23-.66H233c10.75,0.73,16,5.82,16,15.55v16.91a4.57,4.57,0,0,1-4.63,4.5h-3.67a4.57,4.57,0,0,1-4.63-4.5V202.74a2,2,0,0,1,4,0v18.17a0.6,0.6,0,0,0,.63.5h3.67a0.6,0.6,0,0,0,.63-0.5V204c0-7.6-3.53-10.95-12.18-11.55h-8.18q-1.38.12-2.59,0.34a22.56,22.56,0,0,1,1.17,7.58v30.17a5.11,5.11,0,0,1-5.17,5.05h-0.14ZM218.06,194c-3.76,1.74-5.45,5-5.45,10L213,230.5a1.14,1.14,0,0,0,1.18,1.05h3.66a1.14,1.14,0,0,0,1.18-1V200.39a18.24,18.24,0,0,0-1-6.39v0Zm-40.29-.13a18.3,18.3,0,0,0-1,6.56v30.17a1.14,1.14,0,0,0,1.18,1h4.45a1.14,1.14,0,0,0,1.18-1L183.52,204c0-5.2-1.77-8.45-5.74-10.16h0Z"
            transform="translate(-147.33 -152.87)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "people_x2") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96.4 117.9"
      >
        <path
          d="M157.9,158.7a10.76,10.76,0,0,1-10.8-10.8,10.8,10.8,0,1,1,10.8,10.8Zm0-17.7a6.8,6.8,0,1,0,6.8,6.8A6.81,6.81,0,0,0,157.9,141Zm52.3,17.7A10.8,10.8,0,1,1,221,147.9,10.76,10.76,0,0,1,210.2,158.7Zm0-17.7a6.8,6.8,0,1,0,6.8,6.8A6.81,6.81,0,0,0,210.2,141Zm-45.4,20H153.7c-11.2.8-16.7,6.1-16.7,16.2v30.3a4.77,4.77,0,0,0,4.7,4.4h1.7v38.3a4.46,4.46,0,0,0,1.5,3.3,4.67,4.67,0,0,0,3.4,1.3h5.6c1,0,4-.3,4-4.8V210.4h2.4v39.7a4.83,4.83,0,0,0,4.8,4.6h4.4a4.84,4.84,0,0,0,5-4.8V212h1.7a4.76,4.76,0,0,0,4.8-4.6V177.2C181.1,167.2,175.8,161.9,164.8,161Zm11.6,47h-3.2a.61.61,0,0,1-.7-.6V175.9a2,2,0,0,0-4,0v31.6a5,5,0,0,0,2.2,3.8v38.8a.77.77,0,0,1-.9.8h-4.4a.82.82,0,0,1-.9-.8V210.3a3.9,3.9,0,0,0-4-3.8h-2.4a4,4,0,0,0-4.1,3.7V250a1.72,1.72,0,0,1-.1.8h-5.7a.85.85,0,0,1-.6-.2.76.76,0,0,1-.2-.5V211.5a4.6,4.6,0,0,0,2.9-4.3V175.7a2,2,0,0,0-4,0v31.4a.71.71,0,0,1-.8.7h-3.9a.67.67,0,0,1-.7-.6V177.1c0-8,3.7-11.6,12.9-12.2h10.7c8.8.7,12.5,4.4,12.5,12.2v30.1A.61.61,0,0,1,176.4,208Zm40.7-47H206c-11.2.8-16.7,6.1-16.7,16.2v30.3a4.81,4.81,0,0,0,4.7,4.6h1.8v38.2a4.74,4.74,0,0,0,4.7,4.6h5.8c1,0,4-.3,4-4.8V210.5h2.5v39.7a4.83,4.83,0,0,0,4.8,4.6H222a4.84,4.84,0,0,0,5-4.8V212h1.7a4.74,4.74,0,0,0,4.7-4.6V177.2C233.4,167.2,228.1,161.9,217.1,161Zm11.6,47h-3.2a.61.61,0,0,1-.7-.6V175.9a2,2,0,0,0-4,0v31.6a4.83,4.83,0,0,0,2.3,3.8v38.8a.77.77,0,0,1-.9.8h-4.4a.89.89,0,0,1-.9-.7V210.3a3.9,3.9,0,0,0-4-3.8h-2.4a4,4,0,0,0-4.1,3.7h0V250a1.72,1.72,0,0,1-.1.8h-5.7a.71.71,0,0,1-.8-.8V211.5a4.84,4.84,0,0,0,3-4.3V175.6a2,2,0,0,0-4,0v31.5a.71.71,0,0,1-.8.7h-3.9a.67.67,0,0,1-.7-.6V177c0-8,3.7-11.6,12.9-12.2H217c8.8.7,12.5,4.4,12.5,12.2v30.1C229.4,207.7,229.1,208,228.7,208Z"
          transform="translate(-137 -137)"
        />
      </svg>
    );
  }

  if (icon === "people_dance") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 160.93 120.8"
      >
        <path
          d="M159.8,155.4a10.8,10.8,0,1,1,10.8-10.8A10.76,10.76,0,0,1,159.8,155.4Zm0-17.6a6.8,6.8,0,1,0,6.8,6.8A6.87,6.87,0,0,0,159.8,137.8Zm41.3,1.9a1,1,0,0,0-.9-1.1h-3.3a.9.9,0,0,0-.9.9v.2l-.1,1.3c-1.4,16.7-18.3,21-27,20.8h-.2a6.23,6.23,0,0,0-1.9.1l-10.4,1.2a10,10,0,0,0-6.7,3.5l-.7.8c-.4,2-2.3,9-7.9,11.5-4,1.8-8.9,1-14.4-2.4l-1.1-.7a.93.93,0,0,0-1.3.1l-1.9,2.6a1,1,0,0,0,.1,1.3h0c.1,0,.1.1.2.1,7.6,5.1,14.1,6.7,19.3,4.7,6.2-2.4,8.6-9.1,8.8-9.7a2.07,2.07,0,0,1,1-1.4,2.11,2.11,0,0,1,2.4.3,2,2,0,0,1,.6,1.2l5.5,23.6v.3l2.7,50.5v.1a.94.94,0,0,0,1,1h3.6a1,1,0,0,0,1-.9l.9-43.4a3.57,3.57,0,0,1,1.2-2.7,3.32,3.32,0,0,1,2.7-.9,3.37,3.37,0,0,1,2.7,1.3l7.6,8c.1.1.2.2.2.3a4.42,4.42,0,0,1,.8,3.1l1.6,23.8v.2a1.09,1.09,0,0,0,.9,1.1h3a1.06,1.06,0,0,0,1-.9l.2-27.1a2,2,0,0,0-.3-1.1c-14.3-21-14.3-21.5-14.3-22.3l-.3-21.2a2.05,2.05,0,0,1,2.1-2.1,21.43,21.43,0,0,0,19.8-13l2.3,4.3c-5.9,10.1-15.8,12.1-20.1,12.5l.3,18.8c1.3,2.2,8.8,13.5,13.6,20.5a5.48,5.48,0,0,1,1,3.4l-.2,27.2v.1a5,5,0,0,1-5,4.7h-3.4a5.07,5.07,0,0,1-4.7-5.2l-1.6-23.9v-.4a.76.76,0,0,0-.1-.4l-7.2-7.6-.9,42.9a5,5,0,0,1-5,4.8h-3.6a4.93,4.93,0,0,1-5-4.9l-2.7-50.3-4.2-18.1a20.28,20.28,0,0,1-1.3,1.8c-4,4.9-13.3,11.4-30,.3-.1,0-.1-.1-.2-.1s-.2-.1-.3-.2a5.07,5.07,0,0,1-1-7l1.9-2.6a5,5,0,0,1,6.8-1.1l1,.7c4.3,2.7,7.9,3.4,10.6,2.2,4.5-2,5.8-9,5.8-9.1a3,3,0,0,1,.4-1l1-1.2a13.6,13.6,0,0,1,9.3-4.9l10.4-1.2a11.75,11.75,0,0,1,2.7-.1,33.4,33.4,0,0,0,11.2-2.2c7.2-2.8,11.1-7.9,11.7-15l.1-1.2a4.82,4.82,0,0,1,4.9-4.8h3.5a5.16,5.16,0,0,1,4.7,5.3m-31.8,66.6Zm7.4-17.4Zm55.7-33.5a10.8,10.8,0,1,1,10.8-10.8A10.76,10.76,0,0,1,236.4,155.4Zm0-17.6a6.8,6.8,0,1,0,6.8,6.8A6.81,6.81,0,0,0,236.4,137.8Zm-3.2,116.8h-3.6a5,5,0,0,1-5-4.7l-.9-43-7.2,7.6a.76.76,0,0,0-.1.4v.4l-1.6,23.9a5.07,5.07,0,0,1-4.7,5.2h-3.2a5,5,0,0,1-5-4.7v-.1l-.1-27.3a6.06,6.06,0,0,1,1.1-3.5c4.7-7,12.2-18.2,13.5-20.4l.3-18.8c-6.1-.6-23.4-4.4-24.7-29.8a5,5,0,0,1,4.7-5.3h3.5a4.89,4.89,0,0,1,4.9,4.8l.1,1.2c.6,7.2,4.6,12.2,11.8,15a33.74,33.74,0,0,0,11.1,2.1,12.89,12.89,0,0,1,2.8.1l10.4,1.2a13.6,13.6,0,0,1,9.3,4.9l1,1.2a1.78,1.78,0,0,1,.4,1c0,.1,1.2,7.1,5.8,9.1,2.7,1.2,6.3.5,10.6-2.2l1.1-.7a4.88,4.88,0,0,1,6.7,1.1l1.9,2.6a4.73,4.73,0,0,1,.9,3.7,5.3,5.3,0,0,1-1.9,3.3c-.1.1-.2.1-.3.2a.31.31,0,0,1-.2.1c-8.5,5.7-16,7.4-22.4,5.2a18.23,18.23,0,0,1-9-7.3L241,199.3l-2.7,50.3A5.1,5.1,0,0,1,233.2,254.6Zm-9.1-52a3.41,3.41,0,0,1,2.4.9,3.63,3.63,0,0,1,1.2,2.8l.9,43.5a.91.91,0,0,0,1,.8h3.6a.94.94,0,0,0,1-1v-.1l2.7-50.5v-.3l5.5-23.8a1.93,1.93,0,0,1,1.9-1.5,2,2,0,0,1,2,1.4c0,.1,2.5,7.7,9.2,10,5.1,1.8,11.5.1,19-4.9.1,0,.1-.1.2-.1h0a.86.86,0,0,0,.3-.6,1.08,1.08,0,0,0-.2-.7l-1.9-2.6a.82.82,0,0,0-1.2-.1l-1.2.7c-5.5,3.4-10.4,4.3-14.4,2.4-5.6-2.6-7.5-9.5-7.9-11.5l-.7-.8a10,10,0,0,0-6.7-3.5l-10.4-1.2a6.37,6.37,0,0,0-1.9-.1h-.2c-8.7.1-25.6-4.1-27-20.8l-.1-1.3v-.2a.9.9,0,0,0-.9-.9H197a1.09,1.09,0,0,0-.9,1.1c1.3,26.8,21.7,26.2,22.6,26.1a2.05,2.05,0,0,1,2.1,2.1l-.3,21.2v.3c-.1.5-.2,1-14.2,21.9a1.75,1.75,0,0,0-.4,1.2l.1,27.2a1.06,1.06,0,0,0,1,.9h3a1.09,1.09,0,0,0,.9-1.1v-.3l1.6-23.8a5,5,0,0,1,.8-3.1c.1-.1.1-.2.2-.3l7.6-8a3.37,3.37,0,0,1,2.7-1.3A.37.37,0,0,1,224.1,202.6Zm-.4,3.7Zm20.7-31Z"
          transform="translate(-118.13 -133.8)"
        />
      </svg>
    );
  }

  if (icon === "people_friends") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 81.8 117.91"
      >
        <path
          d="M212.4,158.6a10.8,10.8,0,1,1,10.8-10.8A10.76,10.76,0,0,1,212.4,158.6Zm0-17.6a6.8,6.8,0,1,0,6.8,6.8A6.81,6.81,0,0,0,212.4,141Zm23.8,108.8-6.7-38.2h.9a4.61,4.61,0,0,0,4.6-4.4V177.3c0-9.8-5.3-15-16.1-15.9H209a3,3,0,0,1-1-.2c-.4-.2-1.1-.6-2-1.1a48.28,48.28,0,0,0-20.7-7.2,10.79,10.79,0,1,0-20.3-5.1,11.38,11.38,0,0,0,1,4.5h0a4.53,4.53,0,0,0-4.3,4.6v4.7a3.45,3.45,0,0,0,.5,1.8c-4.8,2.6-7.2,7.1-7.2,13.8v30.2a4.81,4.81,0,0,0,4.7,4.6h1.4l-6.6,37.8v.4a4.8,4.8,0,0,0,4.9,4.7H165c.9,0,4-.3,4-4.6l7-39.6v-.2h2.5v39.7a4.58,4.58,0,0,0,1.6,3.4,5,5,0,0,0,3.2,1.3h4.4a4.65,4.65,0,0,0,3.5-1.3,5.2,5.2,0,0,0,1.6-3.4h0V183.4l5.1,4.5.2.2v1.6l-.1,15.4v45a4.74,4.74,0,0,0,4.9,4.7h5.6c1,0,4-.3,4-4.8V210.4h2.6v.2l7,39.6a4.82,4.82,0,0,0,1.5,3.2,5.08,5.08,0,0,0,3.5,1.3h4.3a5,5,0,0,0,4.9-4.5h0C236.2,250.2,236.2,250,236.2,249.8ZM175.8,141a6.8,6.8,0,1,1-6.8,6.8A6.81,6.81,0,0,1,175.8,141ZM192,177.5a2.07,2.07,0,0,0-3.4,1.5v71.1a.85.85,0,0,1-.3.6,1,1,0,0,1-.7.2h-4.3a.88.88,0,0,1-.9-.7V210.3a3.82,3.82,0,0,0-4-3.7h-2.5a3.87,3.87,0,0,0-4,3.6l-7,39.6v.3a1.72,1.72,0,0,1-.1.8h-5.7a.87.87,0,0,1-.8-.6l6.8-38.6a4.54,4.54,0,0,0,3.1-4.2V175.9a2,2,0,0,0-4,0v31.5c0,.4-.4.6-.8.6h-3.9a.67.67,0,0,1-.7-.6V177.2c0-8,3.7-11.6,12.9-12.2h10.7c9.7.8,15.5,5.4,15.5,12.2v5.7Zm39.2,73.4h-4.3a.85.85,0,0,1-.6-.2.85.85,0,0,1-.3-.6v-.3l-7-39.6a3.85,3.85,0,0,0-1.3-2.6,3.66,3.66,0,0,0-2.7-1h-2.5a4.19,4.19,0,0,0-2.8,1,3.63,3.63,0,0,0-1.2,2.8v39.7a1.72,1.72,0,0,1-.1.8h-5.7c-.3,0-.5-.1-.5-.2a.76.76,0,0,1-.2-.5v-45l.1-15.4V177.2c0-9-7.4-15.2-19.3-16.2H171.7l-2.6.3h-3.7v-4.4a.9.9,0,0,1,.9-.9h.2l2.1-.3a10.76,10.76,0,0,0,14,.6,43,43,0,0,1,21.7,6.8,12.09,12.09,0,0,0,2.5,1.3,6.87,6.87,0,0,0,2.4.5H219c8.8.8,12.6,4.4,12.6,12.3V207a.82.82,0,0,1-.9.8h-3.2a1,1,0,0,1-.9-.8V175a1.8,1.8,0,1,0-3.6,0v32.3a4.7,4.7,0,0,0,2.7,4l6.8,39C232.1,250.7,231.8,251,231.2,250.9Z"
          transform="translate(-154.5 -137)"
        />
      </svg>
    );
  }

  if (icon === "people_motorbike") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 156.17 123.5"
      >
        <path
          d="M161.4,213.8H127.9a2,2,0,0,1,0-4h33.5a2,2,0,0,1,0,4Zm-7,6.5a2,2,0,0,0-2-2H136.9a2,2,0,0,0,0,4h15.5A1.94,1.94,0,0,0,154.4,220.3Z"
          transform="translate(-125.9 -137.1)"
        />
        <path
          d="M170.1,250.4a10.8,10.8,0,1,1,10.8-10.8A10.88,10.88,0,0,1,170.1,250.4Zm0-17.6a6.8,6.8,0,1,0,6.8,6.8A6.81,6.81,0,0,0,170.1,232.8Zm0,27.8A20.6,20.6,0,1,1,190.7,240,20.57,20.57,0,0,1,170.1,260.6Zm0-37.3a16.6,16.6,0,1,0,16.6,16.6A16.62,16.62,0,0,0,170.1,223.3Zm107.7,1a20,20,0,0,0-13.8-7.6,18.82,18.82,0,0,0-7.5.6l-2.3-5.7a37.52,37.52,0,0,1,11.3-1.6,2,2,0,0,0,2-2c0-5.4-1.5-9.4-4.6-12.1-4.4-3.9-10.3-3.2-10.5-3.2a4.33,4.33,0,0,0-.5.1l-4.5,1.9-2.6-6.4a4.44,4.44,0,0,0-.8-5.1l-4.2-4.2L230,167.2l-.1-.1c-6.4-6.4-14.8-6.8-20.7-.8-.5.5-1.2,1.2-4.3,12.6l-4.6-1.6.7-2.8c1.1-4.8.9-7.9-.5-10a5.88,5.88,0,0,0-3.8-2.6l-6.9-2.3c-.1,0-.1,0-.2-.1-4.8-1-9.7,3-11.3,9.3l-.3.6-.2.7c-1.4,5.6-2.4,9.8.9,12.9l-4.1,15v.1a5,5,0,0,0,.5,3.4,10,10,0,0,0-4.3,2.3,8.92,8.92,0,0,0-2.7,6.4v.1l.1,3a1.92,1.92,0,0,0,2,1.9,26,26,0,0,1,21.1,11.4l-.3,1.1a4.77,4.77,0,0,0,.5,3.5,4.27,4.27,0,0,0,2.8,2.1h.1a23.54,23.54,0,0,1,.9,6.4,2,2,0,0,0,2,2l31.7.3h.3c3.2,0,4.5-3.7,6-8.3,2.3-6.8,5.4-16,15.1-20.7l2.3,5.6a20.65,20.65,0,0,0-4,2.5,21.13,21.13,0,0,0-8,13.8,20.08,20.08,0,0,0,4,15.2,19.83,19.83,0,0,0,13.8,7.6,17.7,17.7,0,0,0,2.3.1,21.64,21.64,0,0,0,13.1-4.5,20.62,20.62,0,0,0,3.9-29Zm-24.7-27.6a10.1,10.1,0,0,1,7.1,2.2c1.8,1.6,2.8,4,3.1,7.1a41.14,41.14,0,0,0-10.7,1.8l-3.8-9.4Zm-19,3.6a6.9,6.9,0,0,0-2.4-1.8l-8.5-3.9,3.1-12.7,5.6,6.4-3.7,1.4a2,2,0,0,0-1.1,2.6,2.05,2.05,0,0,0,1.9,1.3,1.7,1.7,0,0,0,.7-.1l5.3-2,.4.4a4.53,4.53,0,0,0,6.3-.1l.1-.1,1.9,4.6Zm-22.3-31.5c4.5-4.4,10.4-4.1,15.4.8l9.8,11.8.1.1,4.2,4.2a.82.82,0,0,1-.1,1.2l-2.3,2.3a.92.92,0,0,1-1.2.1l-2.5-2.5L222,171.6a1.84,1.84,0,0,0-2.8,2.4l3.7,4.2-4.1,17.1a2,2,0,0,0,1.1,2.3l10.1,4.6a3,3,0,0,1,1.4,1.3h0a2.12,2.12,0,0,1,0,1.9h0l-2.5,6v.1l-7,19.9a.69.69,0,0,1-.9.3l-3.6-1.5a.55.55,0,0,1-.3-.8c0-.1.1-.1.1-.2l7.1-19.5a2.22,2.22,0,0,0-.1-1.6,2.12,2.12,0,0,0-1.3-1l-12.7-2.9a6.53,6.53,0,0,0-4.7-5.5l-1.9-1c.3-1.1.8-3.3,1.6-6.1l.9.2h.9a4.52,4.52,0,0,0,4.5-3.9l.4-1.7V186c.2-2.1-1.1-5.5-3.7-6.1C210.7,171.3,211.6,169.2,211.8,168.8Zm-14.5,20.8,4.3,1.2c-.6,2.2-1,4.1-1.4,5.3l-4-2.1Zm-8.7-26.1,6.9,2.3c.1,0,.1,0,.2.1a2.22,2.22,0,0,1,1.4.8c.7,1.1.7,3.5-.1,7l-.6,2.4-6.4-2.2a2,2,0,1,0-1.2,3.8l18.3,6.2c.1,0,.2.1.3.1a2.68,2.68,0,0,1,.7,1.7l-.4,1.7v.2a.54.54,0,0,1-.5.5l-10.7-2.9h0l-10.7-2.9a12.39,12.39,0,0,1-3.2-1.3,1.79,1.79,0,0,0-.7-.5c-2-1.6-1.4-3.9-.1-9.4l.1-.3.3-.6C182.9,166.1,185.9,163,188.6,163.5Zm-6.3,21.8a14.27,14.27,0,0,0,2.2.8l9,2.4-1.4,6a2,2,0,0,0,1,2.2l10.8,5.7c.2.1.3.1.5.2a2.53,2.53,0,0,1,1.9,3l-5.4,24.2a.72.72,0,0,1-.9.5l-4.7-.8q-.3-.15-.3-.3a3.54,3.54,0,0,1-.1-.6l4.2-17.5a2,2,0,0,0-1.1-2.3l-18.6-9a.6.6,0,0,0-.4-.1.62.62,0,0,1-.5-.8Zm-10.2,26v-1.1a4.69,4.69,0,0,1,1.5-3.5,5.18,5.18,0,0,1,3.5-1.4H180a1.88,1.88,0,0,0,.8-.2l13.9,6.7-2.3,9.8A30.15,30.15,0,0,0,172.1,211.3Zm59.5,21.2c-.7,2.1-1.7,5-2.4,5.6h-.1l-29.8-.1c-.1-1.2-.3-2.5-.5-3.7l.5.1a3.4,3.4,0,0,0,1,.1,4.8,4.8,0,0,0,4.6-3.6l5-22.5,10.1,2.3L213.7,228h0a4.62,4.62,0,0,0,2.4,6.1l3.6,1.5a5.84,5.84,0,0,0,1.8.4,4.65,4.65,0,0,0,4.3-2.9V233l7-20,2.4-6h0a7.89,7.89,0,0,0,.5-3l9.5-4,3.8,9.4C237.6,214.8,233.9,225.7,231.6,232.5Zm46.2,6.4a17.38,17.38,0,0,1-18.9,14.8,16,16,0,0,1-14.2-18.3,17.09,17.09,0,0,1,6.5-11.2,14.36,14.36,0,0,1,3.1-1.9l2.1,5.2a10.76,10.76,0,1,0,4.9-1.2,3.4,3.4,0,0,0-1,.1L258,221a15.81,15.81,0,0,1,3.8-.4,10.87,10.87,0,0,1,1.8.1,15.94,15.94,0,0,1,11,6.1A15.4,15.4,0,0,1,277.8,238.9Zm-16.6-8.5a6.8,6.8,0,1,1-6.8,6.8A6.81,6.81,0,0,1,261.2,230.4Zm-67.7-71.7a10.8,10.8,0,1,0-10.8-10.8A10.76,10.76,0,0,0,193.5,158.7Zm0-17.7a6.8,6.8,0,1,1-6.8,6.8A6.81,6.81,0,0,1,193.5,141Zm35.4,21.5a10.8,10.8,0,1,0-10.8-10.8A10.76,10.76,0,0,0,228.9,162.5Zm0-17.7a6.8,6.8,0,1,1-6.8,6.8A6.81,6.81,0,0,1,228.9,144.8Z"
          transform="translate(-125.9 -137.1)"
        />
      </svg>
    );
  }

  if (icon === "box_x1") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 65.53 56.81"
      >
        <g>
          <path
            d="M230.84,180.72a2,2,0,0,0-.09-0.55v-0.11a2,2,0,0,0-.24-0.48v-0.05a2,2,0,0,0-.37-0.37h0l-17.6-13a2,2,0,0,0-1.19-.39h-44.2a2,2,0,0,0-.36.06l-0.23.08-0.16.05a0.44,0.44,0,0,0-.15.1l-0.2.14a2,2,0,0,0-.25.25l-0.14.17a2,2,0,0,0-.19.37,1.11,1.11,0,0,0-.07.13h0a2,2,0,0,0-.09.58h0v38.64a2,2,0,0,0,.74,1.55l17.6,14.31,0.08,0.05,0.13,0.09,0.19,0.1,0.14,0.06,0.22,0.07h0.13a2,2,0,0,0,.37,0h43.93a2,2,0,0,0,2-2V180.72Zm-8.09-2H207.53l-12.17-9h15.22Zm-34.14-9,12.17,9H185.57l-12.17-9h15.21Zm-19.31,2,13.6,10V216.5l-13.6-11.06V171.72Zm57.53,47H186.91v-36h39.93v36Z"
            transform="translate(-165.31 -165.77)"
          />
          <path
            d="M205.43,200.22v12.94h15.84V200.22H205.43Zm11.84,8.94h-7.84v-4.94h7.84v4.94Z"
            transform="translate(-165.31 -165.77)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "box_x2") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 114.6 59.42"
      >
        <g>
          <path
            d="M255.37,180.05a2,2,0,0,0-.08-0.54V179.4a2,2,0,0,0-.24-0.48v-0.05a2,2,0,0,0-.36-0.37h0l-18.47-13.6a2,2,0,0,0-1.19-.39H142.62a2,2,0,0,0-.36.06l-0.23.08-0.16.05a0.44,0.44,0,0,0-.15.1l-0.2.14a2,2,0,0,0-.25.25l-0.14.17a2,2,0,0,0-.19.37,1.11,1.11,0,0,0-.07.13h0a2,2,0,0,0-.09.58h0V207a2,2,0,0,0,.74,1.55l18.47,15,0.08,0.05,0.13,0.09,0.19,0.1,0.14,0.06,0.22,0.07h0.13a2,2,0,0,0,.37,0h92.13a2,2,0,0,0,2-2V180.06h0Zm-8.09-2H231l-13-9.6h16.29Zm-62.34,0-13-9.6H188.2l13,9.6H184.94Zm23,0-13-9.6H211.2l13,9.6H207.94Zm-42.82-9.6,13,9.6H161.9l-13-9.6h16.22Zm-20.38,2,14.47,10.66V217.8L144.77,206Zm18.47,11.64h42V220h-42V182.09ZM251.37,220h-42V182.06h42V220Z"
            transform="translate(-140.78 -164.51)"
          />
          <path
            d="M182,212.63h16.42V199.25H182v13.38Zm4-9.38h8.42v5.38H186v-5.38Z"
            transform="translate(-140.78 -164.51)"
          />
          <path
            d="M228,199.25v13.38h16.42V199.25H228Zm12.42,9.38H232v-5.38h8.42v5.38Z"
            transform="translate(-140.78 -164.51)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "box_x3") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 107.42 94.93"
      >
        <g>
          <path
            d="M251.86,200.6a1.88,1.88,0,0,0-.08-0.5V200a1.88,1.88,0,0,0-.23-0.45v-0.05a1.89,1.89,0,0,0-.34-0.35h0l-17.33-12.77a1.89,1.89,0,0,0-1.12-.37h-1.82V161.23a1.88,1.88,0,0,0-.08-0.5v-0.11a1.88,1.88,0,0,0-.23-0.45v-0.05a1.89,1.89,0,0,0-.34-0.35h0L212.72,147a1.89,1.89,0,0,0-1.12-.37H168.2a1.86,1.86,0,0,0-.35.06l-0.22.07-0.15.05-0.14.1-0.19.13a1.7,1.7,0,0,0-.55.74,1.11,1.11,0,0,0-.07.13h0a1.88,1.88,0,0,0-.08.51h0V186H145.56l-0.18.08h-0.07l-0.17.1-0.09.07-0.12.09h0a1.88,1.88,0,0,0-.2.23h0v0.07l-0.07.12a1.87,1.87,0,0,0-.13.27v0.06h0v0.07a1.88,1.88,0,0,0-.06.46h0v38a1.89,1.89,0,0,0,.7,1.47l17.33,14.09h0a1.87,1.87,0,0,0,.49.28h0.09a1.87,1.87,0,0,0,.57.1H250a1.89,1.89,0,0,0,1.89-1.89V200.6h0ZM232,189.74l12.2,9H230.8v-9H232Zm-25.27,9H187.57V163.13H227v24.7h0V198.7Zm-42.63,0-12.2-9h17.38l11.05,9H164.1Zm6.11-46.51,3.2,2.36,10.35,7.62v34.44l-13.55-11V152.23Zm19.12-1.85,12.2,9H186.3l-12.2-9h15.23Zm33.83,9H207.93l-12.2-9H211ZM148,191.61l2,1.39,11.64,8.57V236l-13.55-11Zm17.33,10.92h39.44v35.59H165.39Zm82.69,35.59H208.64V202.5h39.44Z"
            transform="translate(-144.47 -146.63)"
          />
          <path
            d="M182.22,230.91h15.44V218.33H182.22v12.58ZM186,222.1h7.88v5H186v-5Z"
            transform="translate(-144.47 -146.63)"
          />
          <path
            d="M225.44,218.33v12.59h15.44V218.33H225.44Zm11.66,8.81h-7.88v-5h7.88v5Z"
            transform="translate(-144.47 -146.63)"
          />
          <path
            d="M204.4,191.54h15.44V179H204.4v12.54Zm3.78-8.81h7.88v5h-7.88v-5Z"
            transform="translate(-144.47 -146.63)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "box_x4") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 139.26 89.01"
      >
        <g>
          <path
            d="M269,193.37a2,2,0,0,0-.08-0.54v-0.11a2,2,0,0,0-.24-0.48v-0.05a2,2,0,0,0-.36-0.37h0l-16.13-11.88a2,2,0,0,0-1.19-.39h-1.45v-22.8h0a2,2,0,0,0-.08-0.54V156.1a2,2,0,0,0-.24-0.48v-0.05a2,2,0,0,0-.36-0.37h0l-16.13-11.88a2,2,0,0,0-1.19-.39h-80.7a2,2,0,0,0-.36.06l-0.23.08-0.16.05a0.44,0.44,0,0,0-.15.1l-0.2.14a2,2,0,0,0-.25.25l-0.15.18a2,2,0,0,0-.18.36l-0.07.14h0a2,2,0,0,0-.09.57V179.5H131.58a2,2,0,0,0-.36.06l-0.23.08-0.16.05a0.44,0.44,0,0,0-.15.1l-0.2.14a2,2,0,0,0-.25.25l-0.15.18a2,2,0,0,0-.18.36l-0.07.14h0a2,2,0,0,0-.09.57V216.9a2,2,0,0,0,.74,1.55l16.13,13.11,0.08,0.05,0.13,0.09,0.19,0.1,0.14,0.06,0.22,0.07h0.13a2,2,0,0,0,.37,0H267a2,2,0,0,0,2-2V193.38h0Zm-18.78-9.87,10.7,7.88H249.47V183.5h0.75Zm-101.75,7.88-10.7-7.88h13.37l6.42,4.73,3.87,3.15h-13ZM153,148.83l12.13,8.93v31L160.07,185,153,179.32V148.83Zm17.46-2,10.7,7.88H167.77l-10.7-7.88h13.39Zm40.12,0,10.7,7.88H208l-10.7-7.88h13.28Zm-20.12,0,10.7,7.88H186.49l-10.7-7.88h14.67Zm-21.33,44.51V158.75h36.11v32.63H169.12v0Zm19.82,4h35.87V228H188.93Zm37.9-4h-17.5V158.75h36.12v32.63Zm14.54-36.63H227.06l-10.7-7.88h14.33ZM133.73,185.46l12.13,8.93V225.8l-12.13-9.86V185.46Zm16.13,9.92H184.6V228H149.86V195.38ZM265,228H228.84V195.38H265V228Z"
            transform="translate(-129.74 -142.93)"
          />
          <path
            d="M203.42,221.46h14.85V209.27H203.42v12.19Zm4-8.19h6.85v4.19h-6.85v-4.19Z"
            transform="translate(-129.74 -142.93)"
          />
          <path
            d="M243.63,209.27v12.19h14.85V209.27H243.63Zm10.85,8.19h-6.85v-4.19h6.85v4.19Z"
            transform="translate(-129.74 -142.93)"
          />
          <path
            d="M164.68,221.46h14.85V209.27H164.68v12.19Zm4-8.19h6.85v4.19h-6.85v-4.19Z"
            transform="translate(-129.74 -142.93)"
          />
          <path
            d="M224.06,184.83H238.9V172.64H224.06v12.19Zm4-8.19h6.85v4.19h-6.85v-4.19Z"
            transform="translate(-129.74 -142.93)"
          />
          <path
            d="M183.94,184.83h14.85V172.64H183.94v12.19Zm4-8.19h6.85v4.19h-6.85v-4.19Z"
            transform="translate(-129.74 -142.93)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "more_vert") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
    );
  }
  if (icon === "daily") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 94.3 101.45"
      >
        <g>
          <g>
            <g>
              <path
                d="M170,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,170,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,170,193.62Z"
                transform="translate(-150.92 -143.5)"
              />
              {/* <path d="M188.66,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,188.66,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,188.66,193.62Z" transform="translate(-150.92 -143.5)"/> */}
              {/* <path d="M207.08,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,207.08,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,207.08,193.62Z" transform="translate(-150.92 -143.5)"/> */}
              {/* <path d="M226.14,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,226.14,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,226.14,193.62Z" transform="translate(-150.92 -143.5)"/> */}
            </g>
            <g>
              <ellipse cx="19.08" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="19.08" cy="84.33" rx="3.45" ry="3.41" />
              <ellipse cx="37.74" cy="48.75" rx="3.45" ry="3.41" />
              <ellipse cx="37.74" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="37.74" cy="84.33" rx="3.45" ry="3.41" />
              <ellipse cx="56.16" cy="48.75" rx="3.45" ry="3.41" />
              <ellipse cx="56.16" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="56.16" cy="84.33" rx="3.45" ry="3.41" />
              <ellipse cx="75.22" cy="48.75" rx="3.45" ry="3.41" />
              <ellipse cx="75.22" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="75.22" cy="84.33" rx="3.45" ry="3.41" />
            </g>
            <path
              d="M241.3,153.06h-8.47V145.5a2,2,0,0,0-2-2h-8.69a2,2,0,0,0-2,2v7.56H176.59v-7.55a2,2,0,0,0-2-2H165.9a2,2,0,0,0-2,2v7.55h-9.06a3.9,3.9,0,0,0-3.92,3.87v84.15a3.9,3.9,0,0,0,3.92,3.87H241.3a3.9,3.9,0,0,0,3.92-3.87V156.93A3.9,3.9,0,0,0,241.3,153.06Zm-17.16-5.56h4.69v15.11h-4.69V147.5Zm-51.55,0v15.11H167.9v-7.56h0v-7.54h4.69Zm-8.69,9.55v7.56a2,2,0,0,0,2,2h8.69a2,2,0,0,0,2-2v-7.56h43.55v7.56a2,2,0,0,0,2,2h8.69a2,2,0,0,0,2-2v-7.56h8.39v16.61H154.93v-16.6h9Zm-9,83.88V177.68h86.29v63.27Z"
              transform="translate(-150.92 -143.5)"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "weekly") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 94.3 101.45"
      >
        <g>
          <g>
            <g>
              <path
                d="M170,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,170,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,170,193.62Z"
                transform="translate(-150.92 -143.5)"
              />
              <path
                d="M188.66,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,188.66,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,188.66,193.62Z"
                transform="translate(-150.92 -143.5)"
              />
              <path
                d="M207.08,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,207.08,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,207.08,193.62Z"
                transform="translate(-150.92 -143.5)"
              />
              <path
                d="M226.14,185.15a6.23,6.23,0,1,0,6.34,6.23A6.3,6.3,0,0,0,226.14,185.15Zm0,8.47a2.24,2.24,0,1,1,2.34-2.23A2.29,2.29,0,0,1,226.14,193.62Z"
                transform="translate(-150.92 -143.5)"
              />
            </g>
            <g>
              <ellipse cx="19.08" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="19.08" cy="84.33" rx="3.45" ry="3.41" />
              <ellipse cx="37.74" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="37.74" cy="84.33" rx="3.45" ry="3.41" />
              <ellipse cx="56.16" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="56.16" cy="84.33" rx="3.45" ry="3.41" />
              <ellipse cx="75.22" cy="66.54" rx="3.45" ry="3.41" />
              <ellipse cx="75.22" cy="84.33" rx="3.45" ry="3.41" />
            </g>
            <path
              d="M241.3,153.06h-8.47V145.5a2,2,0,0,0-2-2h-8.69a2,2,0,0,0-2,2v7.56H176.59v-7.55a2,2,0,0,0-2-2H165.9a2,2,0,0,0-2,2v7.55h-9.06a3.9,3.9,0,0,0-3.92,3.87v84.15a3.9,3.9,0,0,0,3.92,3.87H241.3a3.9,3.9,0,0,0,3.92-3.87V156.93A3.9,3.9,0,0,0,241.3,153.06Zm-17.16-5.56h4.69v15.11h-4.69V147.5Zm-51.55,0v15.11H167.9v-7.56h0v-7.54h4.69Zm-8.69,9.55v7.56a2,2,0,0,0,2,2h8.69a2,2,0,0,0,2-2v-7.56h43.55v7.56a2,2,0,0,0,2,2h8.69a2,2,0,0,0,2-2v-7.56h8.39v16.61H154.93v-16.6h9Zm-9,83.88V177.68h86.29v63.27Z"
              transform="translate(-150.92 -143.5)"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "fortnightly") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 93.29 103.06"
      >
        <g>
          <g>
            <g>
              <path
                d="M170.24,197.64a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,170.24,197.64Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0v0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M188.73,197.64a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,188.73,197.64Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0v0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M207,197.64a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,207,197.64Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,207,189h0v0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M225.87,197.64a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,225.87,197.64Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0v0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M170.27,205a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,170.27,205Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3h0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M188.76,205a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,188.76,205Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3h0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M207,205a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,207,205Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3h0Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M225.9,205a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,225.9,205Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3h0Z"
                transform="translate(-151.38 -142.7)"
              />
            </g>
            <g>
              <circle cx="18.88" cy="85.68" r="3.44" />
              <circle cx="37.37" cy="85.68" r="3.43" />
              <circle cx="55.62" cy="85.68" r="3.43" />
              <circle cx="74.51" cy="85.68" r="3.43" />
            </g>
            <path
              id="frame"
              d="M240.82,152.41h-8.38V144.7a2,2,0,0,0-2-2h-8.61a2,2,0,0,0-2,2v7.71H176.89V144.7a2,2,0,0,0-2-2h-8.61a2,2,0,0,0-2,2v7.71h-9a3.9,3.9,0,0,0-3.9,3.9v85.55a3.9,3.9,0,0,0,3.9,3.9h85.49a3.9,3.9,0,0,0,3.9-3.9V156.31A3.9,3.9,0,0,0,240.82,152.41Zm-17-5.71h4.61v15.43h-4.61V146.7Zm-50.94,0v15.43h-4.61v-7.72h0v-7.7h4.61Zm67.82,95.05H155.43V177.37h85.29Zm0-68.39H155.43v-17h8.86v7.72a2,2,0,0,0,2,2h8.61a2,2,0,0,0,2-2v-7.72h42.94v7.71a2,2,0,0,0,2,2h8.61a2,2,0,0,0,2-2v-7.71h8.27Z"
              transform="translate(-151.38 -142.7)"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "monthly") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 93.29 103.06"
      >
        <g>
          <g>
            <path
              d="M240.82,152.41h-8.38V144.7a2,2,0,0,0-2-2h-8.61a2,2,0,0,0-2,2v7.71H176.89V144.7a2,2,0,0,0-2-2h-8.61a2,2,0,0,0-2,2v7.71h-9a3.9,3.9,0,0,0-3.9,3.9v85.55a3.9,3.9,0,0,0,3.9,3.9h85.49a3.9,3.9,0,0,0,3.9-3.9V156.31A3.9,3.9,0,0,0,240.82,152.41Zm-17-5.71h4.61v15.43h-4.61V146.7Zm-55.55,0h4.61v15.43h-4.61V146.7Zm-4,9.71v7.72a2,2,0,0,0,2,2h8.61a2,2,0,0,0,2-2v-7.72h42.94v7.71a2,2,0,0,0,2,2h8.61a2,2,0,0,0,2-2v-7.71h8.28v17H155.43v-17h8.84Zm-8.86,85.34V177.37H240.7v64.39H155.41Z"
              transform="translate(-151.38 -142.7)"
            />
            <g>
              <path
                d="M170.25,184.61a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,170.25,184.61Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,170.25,193.22Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M188.75,184.61a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,188.75,184.61Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,188.75,193.22Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M207,184.61a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,207,184.61Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,207,193.22Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M225.89,184.61a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,225.89,184.61Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,225.89,193.22Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M170.25,203.44a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,170.25,203.44Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,170.25,212.05Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M188.75,203.44a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,188.75,203.44Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,188.75,212.05Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M207,203.44a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,207,203.44Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,207,212.05Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M225.89,203.44a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,225.89,203.44Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,225.89,212.05Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M170.25,221.48a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,170.25,221.48Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,170.25,230.09Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M188.75,221.48a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,188.75,221.48Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,188.75,230.09Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M207,221.48a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,207,221.48Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,207,230.09Z"
                transform="translate(-151.38 -142.7)"
              />
              <path
                d="M225.89,221.48a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,225.89,221.48Zm0,8.61a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,225.89,230.09Z"
                transform="translate(-151.38 -142.7)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "bimonthly") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 104.83 114.65"
      >
        <g>
          <g>
            <g>
              <path
                d="M162.39,189.93a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,162.39,189.93Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M180.64,189.93a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,180.64,189.93Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M199.53,189.93a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,199.53,189.93Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M219.22,189.93a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,219.22,189.93Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3,2.3,2.3,0,0,1,2.3-2.3h0Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M162.39,208.77a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,162.39,208.77Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,162.39,200.16Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M180.64,208.77a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,180.64,208.77Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,180.64,200.16Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M199.53,208.77a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,199.53,208.77Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,199.53,200.16Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M219.22,208.77a6.3,6.3,0,1,0-6.3-6.3A6.3,6.3,0,0,0,219.22,208.77Zm0-8.61a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,219.22,200.16Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M168.69,220.5a6.3,6.3,0,1,0-6.3,6.3A6.3,6.3,0,0,0,168.69,220.5Zm-6.3,2.3a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,162.39,222.8Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M186.94,220.5a6.3,6.3,0,1,0-6.3,6.3A6.3,6.3,0,0,0,186.94,220.5Zm-6.3,2.3a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,180.64,222.8Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M205.83,220.5a6.3,6.3,0,1,0-6.3,6.3A6.3,6.3,0,0,0,205.83,220.5Zm-6.3,2.3a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,199.53,222.8Z"
                transform="translate(-144.15 -135.38)"
              />
              <path
                d="M225.53,220.5a6.3,6.3,0,1,0-6.3,6.3A6.3,6.3,0,0,0,225.53,220.5Zm-6.3,2.3a2.3,2.3,0,1,1,2.3-2.3,2.3,2.3,0,0,1-2.3,2.3h0Z"
                transform="translate(-144.15 -135.38)"
              />
            </g>
            <path
              d="M237.45,156.7V149a3.9,3.9,0,0,0-3.9-3.9h-8.39v-7.72a2,2,0,0,0-2-2h-8.61a2,2,0,0,0-2,2v7.72H169.61v-7.71a2,2,0,0,0-2-2H159a2,2,0,0,0-2,2v7.71h-8.95a3.9,3.9,0,0,0-3.9,3.9v85.55a3.9,3.9,0,0,0,3.9,3.9h7.64v7.68a3.9,3.9,0,0,0,3.9,3.9h85.49a3.9,3.9,0,0,0,3.9-3.9V160.6a3.9,3.9,0,0,0-3.9-3.9m-0.1,4v17h-7.53v-17m-16.29-21.29v15.43h-4.61v-7.7h0v-7.71Zm-55.55,0v15.43H161v-7.71h0v-7.7ZM157,149.13v7.72a2,2,0,0,0,2,2h8.61a2,2,0,0,0,2-2v-7.72h42.94v7.71a2,2,0,0,0,2,2h8.61a2,2,0,0,0,2-2v-7.71h8.29v17H148.16v-17H157Zm-8.85,21h85.29v64.39H148.16V170.13Zm11.53,76v-7.58h73.86a3.9,3.9,0,0,0,3.9-3.9v-53H245V246Z"
              transform="translate(-144.15 -135.38)"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "thumbsup") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 91.61 103.36"
      >
        <g>
          <path
            d="M187.45,167.29c-.72-11-4.45-15.29-7.44-18.71-.38-.43-.74-.85-1.09-1.27a16.26,16.26,0,0,0-4.35-3.76c-4.31-2.49-7.52.18-9.64,2l-.34.28c-2.14,1.77-3,5-2.25,8.33a5.21,5.21,0,0,0,2,2.56c2,1.78,5,4.46,4.4,10.11-.75,1.91-4.38,12.35,2,20.41l-2.17,2.17a2,2,0,0,0,2.83,2.83l4.92-4.92-1.41-1.41c-6.89-6.89-2.44-17.69-2.39-17.79l.11-.26v-.28c1-7.9-3.52-11.91-5.67-13.83-.27-.24-.6-.54-.78-.72-.33-1.76,0-3.35.95-4.1l.35-.29c2.26-1.89,3.35-2.56,5.08-1.56a12.29,12.29,0,0,1,3.27,2.85c.37.45.76.9,1.16,1.35,2.73,3.12,5.82,6.65,6.46,16.34a2,2,0,1,0,4-.26Z"
            transform="translate(-152.26 -142.54)"
          />
          <path
            d="M241.49,183.58a8.27,8.27,0,0,0-4-2.24l2.8-2.77a8.32,8.32,0,0,0-6.45-14.22v-.66a8.32,8.32,0,0,0-14.08-6.06,8.31,8.31,0,0,0-14-3.94l-9.36,9.63-10.72,10a2,2,0,0,0,2.63,3l.09-.09,10.76-10,.07-.07,9.37-9.64a4.32,4.32,0,0,1,6.31,5.88L208,169.24l-.16.2-.09.11-.11.2a1.09,1.09,0,0,0-.08.14,2,2,0,0,0-.06.2.23.23,0,0,1-.05.17c-.05.06,0,.13,0,.2V171a.29.29,0,0,0,.05.19c.05.07,0,.12.05.18l.1.2a.19.19,0,0,0,.08.15l.17.21.08.1h0l.22.18.09.07.28.15h.06l.31.09h.83l.25-.07h.12l.23-.12.12-.06.22-.17.1-.08h0l.16,0,6.6-6.48c.17-.17.33-.35.48-.52l4.47-4.43a4.33,4.33,0,1,1,6.29,6l-.21.2L217,178.21a2,2,0,0,0,.3,3.09l.16.08.19.1.18.06.19.06h.75l.21-.06h.16l.18-.09.17-.09a2,2,0,0,0,.31-.25l11.6-11.49a4.33,4.33,0,1,1,6.29,6l-.21.2-11.6,11.49-.13.15-.13.15c0,.05-.06.11-.09.17l-.09.18a.22.22,0,0,1-.05.17,2,2,0,0,0-.06.2v.18a2,2,0,0,0,0,.2v.18a2,2,0,0,0,0,.2v.18q0,.1.06.19c0,.06.06.12.09.18a.92.92,0,0,0,.09.17l.13.17.11.14h0l.15.12.16.13.17.09.18.1.18.06.19.06h.75l.18-.05.19-.05.18-.09.17-.09.17-.14.14-.11h0l3.82-3.71a4.33,4.33,0,0,1,6.08,6.15l-37.08,36.23a2,2,0,0,0,2.8,2.86l37.09-36.24a8.34,8.34,0,0,0,.19-11.79Z"
            transform="translate(-152.26 -142.54)"
          />
          <path
            className={styles.alt_blue}
            d="M196.32,245.9a3.27,3.27,0,0,1-2.31-1l-40.78-40.78a3.12,3.12,0,0,1-.11-4.41L160.8,192a3.12,3.12,0,0,1,4.41.11L206,232.94a3.12,3.12,0,0,1,.11,4.41L198.42,245A3,3,0,0,1,196.32,245.9Zm-39.7-44,39.65,39.65,6.33-6.33L163,195.56Z"
            transform="translate(-152.26 -142.54)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "thumbsdown") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 91.61 103.36"
      >
        <g>
          <path
            d="M187.45,167.29c-.72-11-4.45-15.29-7.44-18.71-.38-.43-.74-.85-1.09-1.27a16.26,16.26,0,0,0-4.35-3.76c-4.31-2.49-7.52.18-9.64,2l-.34.28c-2.14,1.77-3,5-2.25,8.33a5.21,5.21,0,0,0,2,2.56c2,1.78,5,4.46,4.4,10.11-.75,1.91-4.38,12.35,2,20.41l-2.17,2.17a2,2,0,0,0,2.83,2.83l4.92-4.92-1.41-1.41c-6.89-6.89-2.44-17.69-2.39-17.79l.11-.26v-.28c1-7.9-3.52-11.91-5.67-13.83-.27-.24-.6-.54-.78-.72-.33-1.76,0-3.35.95-4.1l.35-.29c2.26-1.89,3.35-2.56,5.08-1.56a12.29,12.29,0,0,1,3.27,2.85c.37.45.76.9,1.16,1.35,2.73,3.12,5.82,6.65,6.46,16.34a2,2,0,1,0,4-.26Z"
            transform="translate(-152.26 -142.54)"
          />
          <path
            d="M241.49,183.58a8.27,8.27,0,0,0-4-2.24l2.8-2.77a8.32,8.32,0,0,0-6.45-14.22v-.66a8.32,8.32,0,0,0-14.08-6.06,8.31,8.31,0,0,0-14-3.94l-9.36,9.63-10.72,10a2,2,0,0,0,2.63,3l.09-.09,10.76-10,.07-.07,9.37-9.64a4.32,4.32,0,0,1,6.31,5.88L208,169.24l-.16.2-.09.11-.11.2a1.09,1.09,0,0,0-.08.14,2,2,0,0,0-.06.2.23.23,0,0,1-.05.17c-.05.06,0,.13,0,.2V171a.29.29,0,0,0,.05.19c.05.07,0,.12.05.18l.1.2a.19.19,0,0,0,.08.15l.17.21.08.1h0l.22.18.09.07.28.15h.06l.31.09h.83l.25-.07h.12l.23-.12.12-.06.22-.17.1-.08h0l.16,0,6.6-6.48c.17-.17.33-.35.48-.52l4.47-4.43a4.33,4.33,0,1,1,6.29,6l-.21.2L217,178.21a2,2,0,0,0,.3,3.09l.16.08.19.1.18.06.19.06h.75l.21-.06h.16l.18-.09.17-.09a2,2,0,0,0,.31-.25l11.6-11.49a4.33,4.33,0,1,1,6.29,6l-.21.2-11.6,11.49-.13.15-.13.15c0,.05-.06.11-.09.17l-.09.18a.22.22,0,0,1-.05.17,2,2,0,0,0-.06.2v.18a2,2,0,0,0,0,.2v.18a2,2,0,0,0,0,.2v.18q0,.1.06.19c0,.06.06.12.09.18a.92.92,0,0,0,.09.17l.13.17.11.14h0l.15.12.16.13.17.09.18.1.18.06.19.06h.75l.18-.05.19-.05.18-.09.17-.09.17-.14.14-.11h0l3.82-3.71a4.33,4.33,0,0,1,6.08,6.15l-37.08,36.23a2,2,0,0,0,2.8,2.86l37.09-36.24a8.34,8.34,0,0,0,.19-11.79Z"
            transform="translate(-152.26 -142.54)"
          />
          <path
            className={styles.alt_blue}
            d="M196.32,245.9a3.27,3.27,0,0,1-2.31-1l-40.78-40.78a3.12,3.12,0,0,1-.11-4.41L160.8,192a3.12,3.12,0,0,1,4.41.11L206,232.94a3.12,3.12,0,0,1,.11,4.41L198.42,245A3,3,0,0,1,196.32,245.9Zm-39.7-44,39.65,39.65,6.33-6.33L163,195.56Z"
            transform="translate(-152.26 -142.54)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "wallet") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 87.95 92.83"
      >
        <g>
          <g>
            <path
              d="M232,177.26L220.49,154.9a2.81,2.81,0,0,0-3.78-1.21h0l-3.57,1.84L208.49,149a2.81,2.81,0,0,0-3.92-.67h0l-39.92,28.26A2,2,0,1,0,166.8,180l0.16-.11,39-27.57,3.64,5.14-36.88,19a2,2,0,1,0,1.67,3.63l0.11-.05,43-22.16,2.23,4.33L192,176.4a2,2,0,0,0,1.83,3.56l27.68-14.27,6.91,13.41a2,2,0,0,0,3.56-1.83h0Z"
              transform="translate(-154.11 -147.81)"
            />
            <g>
              <path
                d="M239.57,198.53V185.41a9.24,9.24,0,0,0-9.23-9.23h-67a9.24,9.24,0,0,0-9.23,9.23v46a9.24,9.24,0,0,0,9.23,9.23h67a9.24,9.24,0,0,0,9.23-9.22l0.09-14.11a3.53,3.53,0,0,0,1.33-.82,3.62,3.62,0,0,0,1.07-2.58V202A3.61,3.61,0,0,0,239.57,198.53Zm-1.51,3.81v11.22H217.75a3,3,0,0,1-2.24-.81,3.64,3.64,0,0,1-1.11-2.66V206a3.59,3.59,0,0,1,3.49-3.67h20.17Zm-7.73,34.35h-67a5.24,5.24,0,0,1-5.23-5.23v-46a5.24,5.24,0,0,1,5.23-5.23h67a5.24,5.24,0,0,1,5.23,5.23V198.4H217.89a7.59,7.59,0,0,0-7.49,7.6v4.08a7.65,7.65,0,0,0,2.38,5.58,6.93,6.93,0,0,0,4.77,1.9h18.12l-0.09,13.89a5.24,5.24,0,0,1-5.24,5.24h0Z"
                transform="translate(-154.11 -147.81)"
              />
              <circle cx="66.92" cy="60.15" r="3.3" />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "card") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 111.11 72.56"
      >
        <g>
          <g>
            <path
              d="M184.72,195.1a11.07,11.07,0,0,0,2.79-7.4c0-5.93-4.54-10.76-10.12-10.76s-10.12,4.83-10.12,10.76a11.07,11.07,0,0,0,2.79,7.4,11.13,11.13,0,0,0-7.74,10.59v12.63h4V205.69a7.12,7.12,0,0,1,7.11-7.11h7.91a7.12,7.12,0,0,1,7.11,7.11v12.63h4V205.69A11.13,11.13,0,0,0,184.72,195.1ZM177.39,181c3.38,0,6.13,3,6.13,6.76s-2.75,6.76-6.12,6.76-6.12-3-6.12-6.76,2.72-6.76,6.11-6.76h0Z"
              transform="translate(-142.5 -158)"
            />
            <g>
              <path
                d="M245.7,158H150.5a8,8,0,0,0-8,8v56.56a8,8,0,0,0,8,8h95.2a7.92,7.92,0,0,0,7.91-7.91V165.89A7.92,7.92,0,0,0,245.7,158Zm3.91,64.59a3.91,3.91,0,0,1-3.91,3.91H150.5a4,4,0,0,1-4-4V165.95a4,4,0,0,1,4-4h95.2a3.91,3.91,0,0,1,3.91,3.91h0v56.73Z"
                transform="translate(-142.5 -158)"
              />
              <path
                d="M198.07,167.8H156.76a3.5,3.5,0,0,0-3.5,3.5v45.86a3.5,3.5,0,0,0,3.5,3.5h41.31a3.5,3.5,0,0,0,3.5-3.5V171.3A3.5,3.5,0,0,0,198.07,167.8Zm-0.5,48.86H157.26V171.8h40.31v44.86Z"
                transform="translate(-142.5 -158)"
              />
              <circle cx="92.61" cy="16.28" r="3.3" />
            </g>
            <g>
              <path
                d="M238.42,213.41H210.66a2,2,0,0,0,0,4h27.75a2,2,0,0,0,0-4h0Z"
                transform="translate(-142.5 -158)"
              />
              <path
                d="M238.42,194.5H210.66a2,2,0,0,0,0,4h27.75a2,2,0,0,0,0-4h0Z"
                transform="translate(-142.5 -158)"
              />
              <path
                d="M210.79,207.85h11a1.82,1.82,0,1,0,0-3.64h-11A1.82,1.82,0,0,0,210.79,207.85Z"
                transform="translate(-142.5 -158)"
              />
              <path
                d="M238.42,207.85a1.82,1.82,0,0,0,0-3.64h-11a1.82,1.82,0,1,0,0,3.64h11Z"
                transform="translate(-142.5 -158)"
              />
              <path
                d="M238.42,185H210.66a2,2,0,0,0,0,4h27.75a2,2,0,0,0,0-4h0Z"
                transform="translate(-142.5 -158)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "pig") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 121.07 84.35"
      >
        <g>
          <g>
            <path
              d="M208.63,165.1H192.88a2,2,0,0,0,0,4h15.75A2,2,0,0,0,208.63,165.1Z"
              transform="translate(-137.51 -154.6)"
            />
            <g>
              <path
                d="M253.68,178.08h-6.84a33.58,33.58,0,0,0-32-23.48H186.65a33.47,33.47,0,0,0-26.33,12.81,7.72,7.72,0,0,0-12.38-2,3.76,3.76,0,0,1-5.32-5.32,2,2,0,1,0-2.83-2.83,7.78,7.78,0,0,0,11,11A3.76,3.76,0,0,1,157,172a2,2,0,0,0-.07.57,33.31,33.31,0,0,0-3.85,15.58v1A33.55,33.55,0,0,0,171.38,219v15a5,5,0,0,0,4.95,4.95h11.14a5,5,0,0,0,4.95-4.95V222.6h19.12v11.3a5,5,0,0,0,4.95,4.95h11.14a5,5,0,0,0,4.95-4.95V217.49a33.67,33.67,0,0,0,14.21-18.36h6.84a5,5,0,0,0,5-4.95V183A5,5,0,0,0,253.68,178.08ZM188.47,233.9a1,1,0,0,1-.95.95h-0.67v-3.5a2,2,0,0,0-4,0v3.5H181v-3.5a2,2,0,0,0-4,0v3.5h-0.67a1,1,0,0,1-.95-0.95V220.67a33.36,33.36,0,0,0,11.22,1.94h1.82Zm40.16,0a1,1,0,0,1-.95.95H227v-3.5a2,2,0,0,0-4,0v3.5h-1.8v-3.5a2,2,0,0,0-4,0v3.5h-0.67a1,1,0,0,1-.95-0.95V222.59a33.3,33.3,0,0,0,13-3Zm-13.77-15.3H186.65a29.56,29.56,0,0,1-29.52-29.52v-1a29.56,29.56,0,0,1,29.52-29.52h28.21a29.56,29.56,0,0,1,29.52,29.52v1a29.56,29.56,0,0,1-29.53,29.52h0Zm39.77-24.43a1,1,0,0,1-.95.95h-5.86a33.56,33.56,0,0,0,.56-6v-1a33.56,33.56,0,0,0-.56-6h5.86a1,1,0,0,1,.95.95v11.1Z"
                transform="translate(-137.51 -154.6)"
              />
              <path
                d="M229.93,178.08a6.05,6.05,0,1,0,6.05,6.05A6.05,6.05,0,0,0,229.93,178.08Zm0,8.11a2.05,2.05,0,1,1,2.05-2.05,2.05,2.05,0,0,1-2.05,2.05h0Z"
                transform="translate(-137.51 -154.6)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "reference") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 86.84 82"
      >
        <g>
          <g>
            <g>
              <path
                d="M190.47,231.18a41,41,0,1,1,41-41h0a42.74,42.74,0,0,1-3.17,15.52l7.88,22.63A2,2,0,0,1,233.9,231l-24-4.67A41,41,0,0,1,190.47,231.18Zm0-78a37,37,0,1,0,18.13,69.26,2,2,0,0,1,1.36-.22l21.28,4.14-7-20.06a2,2,0,0,1,0-1.43,38.91,38.91,0,0,0,3.16-14.68A37,37,0,0,0,190.47,153.18Z"
                transform="translate(-149.47 -149.18)"
              />
            </g>
            <g>
              <path
                d="M173.77,176.54h33.4a1.64,1.64,0,0,0,0-3.28h-33.4a1.64,1.64,0,0,0,0,3.28h0Z"
                transform="translate(-149.47 -149.18)"
              />
              <path
                d="M207.17,183.78h-33.4a1.64,1.64,0,0,0,0,3.28h33.4a1.64,1.64,0,0,0,0-3.28h0Z"
                transform="translate(-149.47 -149.18)"
              />
              <path
                d="M207.17,194.3h-33.4a1.64,1.64,0,0,0,0,3.28h33.4a1.64,1.64,0,0,0,0-3.28h0Z"
                transform="translate(-149.47 -149.18)"
              />
              <path
                d="M207.17,204.82h-33.4a1.64,1.64,0,0,0,0,3.28h33.4a1.64,1.64,0,0,0,0-3.28h0Z"
                transform="translate(-149.47 -149.18)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "email") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 102.25 100.85"
      >
        <g>
          <path
            d="M248.64,181.12L211.9,144.38h0a2,2,0,0,0-.45-0.33H211.4a2,2,0,0,0-.53-0.17h-0.08a2,2,0,0,0-.5,0H210.2a2,2,0,0,0-.51.16l-0.11.06a2,2,0,0,0-.46.33L158,195.55a2,2,0,0,0-.34.46l-0.05.1a2,2,0,0,0-.17.52v0.09a2,2,0,0,0,0,.5v0.08a2,2,0,0,0,.17.53v0.11a2,2,0,0,0,.23.33l0.07,0.08h0l36.75,36.75a2,2,0,0,0,2.83,0h0L248.62,184a2,2,0,0,0,0-2.83h0ZM198,229l-6.58-35.52,12-2a2,2,0,0,0,1.63-1.63L207.24,177l35.68,7.13Zm3.31-41.28-36,6.17,42.22-42.22Zm-13.83,6.43,6.37,34.4-30.3-30.3ZM207.84,173l4-23.08,29.83,29.83Z"
            transform="translate(-146.96 -143.86)"
          />
          <g id="lines">
            <path
              d="M162.83,217.5a2,2,0,0,0-2.83-.12h0l-12.44,11.44a2,2,0,0,0,2.71,2.94l12.44-11.44A2,2,0,0,0,162.83,217.5Z"
              transform="translate(-146.96 -143.86)"
            />
            <path
              d="M163.06,228.73a2,2,0,0,0,2.82.22h0L172.8,223a2,2,0,1,0-2.6-3l-6.93,5.93A2,2,0,0,0,163.06,228.73Z"
              transform="translate(-146.96 -143.86)"
            />
            <path
              d="M173.51,231.61a2,2,0,0,0-2.82-.14h0L160,241.2a2,2,0,1,0,2.69,3l10.73-9.73a2,2,0,0,0,.12-2.83Z"
              transform="translate(-146.96 -143.86)"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (icon === "sad_card") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 396.14 388.46"
      >
        <g>
          <path
            className={styles.sad_card_cls_1}
            d="M227.41,241.73H168.8a7.68,7.68,0,0,1-7.81-7.51v-80a7.68,7.68,0,0,1,7.81-7.51h58.61a7.62,7.62,0,0,1,7.75,7.46v80.08A7.62,7.62,0,0,1,227.41,241.73Zm-58.61-91a3.68,3.68,0,0,0-3.81,3.51v80a3.68,3.68,0,0,0,3.81,3.51h58.61a3.62,3.62,0,0,0,3.75-3.46V154.19a3.62,3.62,0,0,0-3.75-3.46Zm29.28,63.83M223,162.72a2,2,0,0,0-2-2H188.11a2,2,0,1,0,0,4H221A2,2,0,0,0,223,162.72Zm0,10.12a2,2,0,0,0-2-2H175.09a2,2,0,1,0,0,4H221A2,2,0,0,0,223,172.84Zm-40.83-10.12a2,2,0,0,0-2-2h-5.06a2,2,0,1,0,0,4h5.06A2,2,0,0,0,182.15,162.72Zm31.32,57a2,2,0,0,0-.87-2.69,32.09,32.09,0,0,0-29,0,2,2,0,0,0,1.82,3.56,28.07,28.07,0,0,1,25.41,0,2,2,0,0,0,2.69-.87Zm-8.05,6.08a2,2,0,0,0-.87-2.69,14.29,14.29,0,0,0-12.94,0,2,2,0,1,0,1.82,3.56,10.28,10.28,0,0,1,9.31,0,2,2,0,0,0,2.69-.87Zm-10.88-35.17a2,2,0,1,0-3.58-1.79c-1,2-3.75,3.29-7,3.29s-6-1.29-7-3.29a2,2,0,0,0-3.58,1.79c1.7,3.39,5.75,5.5,10.58,5.5S192.84,194,194.53,190.63Zm27.79,0a2,2,0,0,0-3.58-1.79c-1,2-3.75,3.29-7,3.29s-6-1.29-7-3.29a2,2,0,0,0-3.58,1.79c1.7,3.39,5.75,5.5,10.58,5.5S220.62,194,222.32,190.63ZM223,202v-2a2,2,0,0,0-4,0v2a2,2,0,0,0,4,0Zm0,9.2v-2a2,2,0,0,0-4,0v2a2,2,0,0,0,4,0Z"
          />
        </g>
      </svg>
    );
  }

  if (icon === "happy_card") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 80.2 101.7"
      >
        <g>
          <path
            className={styles.happy_card_cls_1}
            d="M69.3,98.6H10.7c-4.2,0.1-7.7-3.3-7.8-7.5v-80c0.1-4.2,3.6-7.6,7.8-7.5h58.6c4.2-0.1,7.7,3.3,7.8,7.5v80.1C76.9,95.3,73.5,98.7,69.3,98.6z M10.7,7.6c-2-0.1-3.7,1.5-3.8,3.5v80c0.1,2,1.8,3.6,3.8,3.5h58.6c2,0.1,3.7-1.5,3.8-3.5V11c-0.1-2-1.8-3.5-3.8-3.5H10.7z M64.9,19.6c0-1.1-0.9-2-2-2H30c-1.1,0-2,0.9-2,2s0.9,2,2,2h32.9C64,21.6,64.9,20.7,64.9,19.6zM64.9,29.7c0-1.1-0.9-2-2-2H17c-1.1,0-2,0.9-2,2s0.9,2,2,2h45.9C64,31.7,64.9,30.8,64.9,29.7z M24,19.6c0-1.1-0.9-2-2-2H17c-1.1,0-2,0.9-2,2s0.9,2,2,2H22C23.1,21.6,24,20.7,24,19.6L24,19.6z M55.4,73.5c-0.5-1-1.7-1.4-2.7-0.9c-8,4.1-17.4,4.1-25.4,0c-1-0.5-2.1-0.1-2.6,0.8c-0.5,1-0.2,2.2,0.8,2.7c9.1,4.6,19.9,4.6,29,0C55.5,75.7,55.9,74.5,55.4,73.5L55.4,73.5zM36.4,48.1c-1.7-3.4-5.7-5.5-10.6-5.5s-8.9,2.1-10.6,5.5c-0.5,1-0.1,2.2,0.9,2.7s2.2,0.1,2.7-0.9c1-2,3.8-3.3,7-3.3s6,1.3,7,3.3c0.5,1,1.7,1.4,2.7,0.9S36.9,49.1,36.4,48.1L36.4,48.1zM64.2,48.1c-1.7-3.4-5.7-5.5-10.6-5.5s-8.9,2.1-10.6,5.5c-0.5,1-0.1,2.2,0.9,2.7s2.2,0.1,2.7-0.9c1-2,3.8-3.3,7-3.3s6,1.3,7,3.3c0.5,1,1.7,1.4,2.7,0.9C64.3,50.3,64.7,49.1,64.2,48.1L64.2,48.1z"
          />
        </g>
      </svg>
    );
  }

  if (icon === "notification") {
    return <i className={`${styles.icon_notification} fas fa-bell fa-3x`}></i>;
  }

  if (icon === "hands") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 111.79 103.62"
      >
        <g>
          <path
            d="M173.88,154.35a2,2,0,1,0,2.83-2.83l-8.36-8.36a2,2,0,0,0-2.83,2.83Z"
            transform="translate(-142.19 -142.41)"
          />
          <path
            d="M145.6,168.7a2,2,0,0,0-2.82,2.84l7,6.94a2,2,0,0,0,2.82-2.84Z"
            transform="translate(-142.19 -142.41)"
          />
          <path
            d="M237.36,199.56l-1.23-1L218,181l-2.83-2.83c3.51-.41,7.73-1.25,10.16-2.48a25.23,25.23,0,0,0,6.77-5,2,2,0,0,0-2.87-2.78,21.25,21.25,0,0,1-5.7,4.21c-2.68,1.35-8.85,2.24-12.1,2.34a2,2,0,0,0-1.73,1.13c-7.88,8.11-9.07,13.08-9.85,16.39l-.12.49a21.3,21.3,0,0,1-2.26,5.65c-1.29,1.57-3,2.39-4.26,2.09-2-.46-3.36-2.42-3.75-5.38a13.18,13.18,0,0,1,.28-4.6c1.06-4.71,4.49-16.49,13.29-24.28l.1-.1s3-2.94,11.07-6.88l.31-.15,12.9-13a2,2,0,0,0-2.84-2.82l-12.42,12.49c-8.05,3.94-11.31,7-11.82,7.47a38.72,38.72,0,0,0-5.3,5.83,2,2,0,0,0-.32-.39L185.28,160a2,2,0,0,0-2.67,3L192,171.4a2,2,0,0,0,.89.45,58.32,58.32,0,0,0-7.09,17.47,17.15,17.15,0,0,0-.35,6c.61,4.64,3.15,7.91,6.82,8.76a6.38,6.38,0,0,0,1.44.16,9.11,9.11,0,0,0,6.81-3.6c1.41-1.71,2.74-5.91,3.06-7.25l.12-.51c.63-2.69,1.58-6.64,7.49-13.11a2,2,0,0,0,.29.39l3.67,3.67,18.26,17.6.12.1,1.21,1a4.33,4.33,0,0,1-6.18,6.06l-8.72-8.72a2,2,0,0,0-2.83,2.83l8.72,8.72h0l5,5a4.33,4.33,0,0,1-5.91,6.33l-.21-.21-13.72-13.72a2,2,0,0,0-2.83,2.83h0l13.72,13.72a4.33,4.33,0,0,1-6.12,6.12L202,217.77a2,2,0,0,0-2.83,2.83l13.72,13.72a4.33,4.33,0,1,1-6.13,6.1L204,237.83c2.8-2.9,2.56-7.78-.59-11a8.57,8.57,0,0,0-6.2-2.6v-.71a8.87,8.87,0,0,0-8-8.13h-.71a8.81,8.81,0,0,0-8-8.83h-.71a8.58,8.58,0,0,0-2.53-6.23,9.15,9.15,0,0,0-1.15-1,2,2,0,0,0-.48-.81l-14.35-14.3a2,2,0,0,0-2.82,2.83l10.91,10.87a6.86,6.86,0,0,0-3.16,1.77l-7.54,7.45a2,2,0,0,0-.39,2.29,6.57,6.57,0,0,0,.23,1.87A12,12,0,0,0,166,219a7.12,7.12,0,0,0,1,.21,10.32,10.32,0,0,0,3,5.72,11.19,11.19,0,0,0,4.67,2.95,7.12,7.12,0,0,0,1,.21,11.5,11.5,0,0,0,8.71,8.89,7,7,0,0,0,.19,1,11.19,11.19,0,0,0,2.85,4.73A9.67,9.67,0,0,0,194,246h.52a1.94,1.94,0,0,0,1.91-.5l.53-.52.17-.13,4.14-4.06,2.68,2.62a8.32,8.32,0,0,0,14.18-6.54h.66a8.31,8.31,0,0,0,8.32-8.3q0-.35,0-.7h.66a8.32,8.32,0,0,0,5.91-14.18,8.32,8.32,0,0,0,3.92-14Zm-73.21,13.69c-1.93-2-2.11-3.77-1.9-4l4.84-4.74a2,2,0,0,0,.28-.35l1.57-1.55a3.12,3.12,0,0,1,2.46-.83,4.66,4.66,0,0,1,2.95,1.42c1.63,1.65,1.87,4.08.52,5.42l-6.76,6.68C167.74,215.41,166,215.15,164.15,213.25Zm8.7,8.88c-1.93-2-2.11-3.77-1.9-4l4.84-4.74a2,2,0,0,0,.28-.35l1.6-1.59a3.13,3.13,0,0,1,2.46-.83,4.66,4.66,0,0,1,2.95,1.42c1.63,1.65,1.87,4.08.52,5.42l-6.8,6.72c-.36.12-2.09-.18-3.95-2Zm6.81,4.84,4.84-4.74a2,2,0,0,0,.28-.35l1.64-1.62a3.13,3.13,0,0,1,2.46-.83,4.87,4.87,0,0,1,4.33,4.38,3.11,3.11,0,0,1-.86,2.45L185.52,233c-.37.17-2.1-.09-4-2s-2.07-3.75-1.86-4Zm8.7,8.88,4.84-4.74a2,2,0,0,0,.28-.35l1.68-1.66c1.35-1.33,3.77-1.07,5.41.58s1.87,4.08.52,5.42l-1.17,1.16-.2.17-.12.15-5.38,5.32c-.37.17-2.1-.09-4-2s-2.07-3.77-1.86-4Z"
            transform="translate(-142.19 -142.41)"
          />
          <path
            d="M253.37,170a2,2,0,0,0-2.83,0h0l-12.75,12.67a2,2,0,0,0-.5.85v.22a2,2,0,0,0-.06.58c.15,2.28-1.32,7.56-1.8,9.3a2,2,0,0,0,3.8,1.24q0-.09,0-.17a46.13,46.13,0,0,0,1.95-9.76l12.18-12.1a2,2,0,0,0,0-2.83Z"
            transform="translate(-142.19 -142.41)"
          />
          <path
            className={styles.alt_blue}
            d="M188,157.46l-8.61-8.61a2.06,2.06,0,0,0-2.83,0l-8.85,8.85a2,2,0,0,0-.36.51,11.38,11.38,0,0,0-10.85,10.71h0l-8.77,8.77a2,2,0,0,0,0,2.83h0l8.61,8.61a2,2,0,0,0,2.83,0h0l8.23-8.23h.48a11.4,11.4,0,0,0,11.38-11.38V169l8.79-8.79A2,2,0,0,0,188,157.46ZM157.72,184.9l-5.79-5.79,5.34-5.34a11.43,11.43,0,0,0,5.57,6Zm10.12-8a7.38,7.38,0,1,1,7.38-7.38,7.38,7.38,0,0,1-7.38,7.38h0Zm10.21-12.37a11.43,11.43,0,0,0-6-5.57l5.9-5.9,5.79,5.79Z"
            transform="translate(-142.19 -142.41)"
          />
          <path
            className={styles.alt_blue}
            d="M170.91,168.78h-.72v-2.95a2,2,0,0,0-4,0v4.95a2,2,0,0,0,2,2h2.72a2,2,0,0,0,0-4Z"
            transform="translate(-142.19 -142.41)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "glasses") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 151.73 82.19"
      >
        <g>
          <path
            className={styles.glasses_cls_1}
            d="M188.06,197.31a2.5,2.5,0,0,0-1.29,3.29,16.5,16.5,0,0,1,1.38,6.67v.4c0,12.48-9.61,22.63-21.43,22.63h-4.09c-11.82,0-21.43-10.15-21.43-22.63v-6a2.5,2.5,0,1,0-5,0v6c0,15.24,11.86,27.63,26.43,27.63h4.09c14.58,0,26.43-12.4,26.43-27.63v-.4a21.47,21.47,0,0,0-1.81-8.68A2.5,2.5,0,0,0,188.06,197.31Z"
            transform="translate(-122.25 -153.15)"
          />
          <path
            className={styles.glasses_cls_1}
            d="M257.45,199.2a2.5,2.5,0,0,0-2.5,2.5v6c0,12.48-9.61,22.63-21.43,22.63h-4.09c-11.82,0-21.43-10.15-21.43-22.63v-.4a16.51,16.51,0,0,1,1.38-6.67,2.5,2.5,0,0,0-4.58-2,21.48,21.48,0,0,0-1.81,8.68v.4c0,15.24,11.86,27.63,26.43,27.63h4.09c14.58,0,26.43-12.4,26.43-27.63v-6a2.5,2.5,0,0,0-2.49-2.51Z"
            transform="translate(-122.25 -153.15)"
          />
          <path
            className={styles.glasses_cls_2}
            d="M273.94,189.19V189a2.84,2.84,0,0,0-.9-1.85l-13.82-19.27-.08-.1c-2.34-2.94-4-5.23-5.35-7.08-4.11-5.64-5.49-7.54-12.16-7.54h-7.17a2.5,2.5,0,0,0,0,5h7.17c4.12,0,4.2.1,8.11,5.48,1.36,1.88,3.06,4.21,5.45,7.2L266,186l-28.48-2.2a38.55,38.55,0,0,0-5.91-.45h-.05c-11,0-20.93,5.29-25.85,13.79a2.67,2.67,0,0,1-.6.68l-.49.08a57.63,57.63,0,0,1-6.56.78,57.48,57.48,0,0,1-6.58-.78l-.49-.08a2.66,2.66,0,0,1-.6-.68c-4.93-8.5-14.83-13.79-25.85-13.79h-.05a38.55,38.55,0,0,0-5.91.45L130.11,186,141,170.83c2.39-3,4.08-5.33,5.45-7.2,3.92-5.38,4-5.48,8.11-5.48h7.17a2.5,2.5,0,1,0,0-5h-7.17c-6.67,0-8,1.9-12.15,7.54-1.34,1.85-3,4.14-5.36,7.08l-.08.1-13.82,19.27a2.83,2.83,0,0,0-.9,1.85v.19h0v6a2.84,2.84,0,0,0,2.83,2.84,4.72,4.72,0,0,1,3.39,1.45,5.35,5.35,0,0,1,1.51,3.9v1.7a4.17,4.17,0,0,0,1.18,3,4,4,0,0,0,2.87,1.21h2.7a4.07,4.07,0,0,0,4-3.77c.66-8.57,8.16-15.13,18.54-16.81l5.43-.42c9.08,0,17.5,4.46,21.46,11.3a7.63,7.63,0,0,0,1.5,1.83,5.23,5.23,0,0,0,2,1.29l1.19.31H191a31.21,31.21,0,0,0,7.1.56,31.22,31.22,0,0,0,7.08-.56h.18l1.19-.31a5.24,5.24,0,0,0,2-1.29,7.64,7.64,0,0,0,1.5-1.83c4-6.84,12.38-11.27,21.46-11.3l5.43.42c10.38,1.68,17.88,8.23,18.54,16.81a4.07,4.07,0,0,0,4,3.77h2.7a4,4,0,0,0,2.86-1.21,4.17,4.17,0,0,0,1.18-3v-1.7a5.35,5.35,0,0,1,1.51-3.9,4.72,4.72,0,0,1,3.39-1.45,2.84,2.84,0,0,0,2.83-2.84v-6ZM135.75,204.31h-.84v-.79A10.46,10.46,0,0,0,132,196a9.76,9.76,0,0,0-4.79-2.71v-2.1l16.82-1.3A21.58,21.58,0,0,0,135.75,204.31Zm133.2-11a9.75,9.75,0,0,0-4.79,2.71,10.46,10.46,0,0,0-2.94,7.5v.79h-.84a21.58,21.58,0,0,0-8.27-14.4l16.82,1.3Z"
            transform="translate(-122.25 -153.15)"
          />
          <path
            className={styles.glasses_cls_3}
            d="M232.47,219.23a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,232.47,219.23Zm0-11a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,232.47,208.23Z"
            transform="translate(-122.25 -153.15)"
          />
          <path
            className={styles.glasses_cls_3}
            d="M163.72,219.23a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,163.72,219.23Zm0-11a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,163.72,208.23Z"
            transform="translate(-122.25 -153.15)"
          />
        </g>
      </svg>
    );
  }
  if (icon === "credit_card") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 396.14 388.46"
      >
        <g>
          <path
            className={styles.credit_card_cls_1}
            d="M214,145.77h0l0,0a2,2,0,0,0-.45-.33l0,0-.05,0a2,2,0,0,0-.53-.17h-.08a2,2,0,0,0-.5,0h-.09a2,2,0,0,0-.51.16l-.11.06a2,2,0,0,0-.46.33L160,196.87a2,2,0,0,0-.33.46l-.05.1a2,2,0,0,0-.17.52s0,.06,0,.09a2,2,0,0,0,0,.5s0,.05,0,.08a2,2,0,0,0,.17.53l0,.05,0,.06a2,2,0,0,0,.23.33l.07.08,0,0L195.34,235a2,2,0,0,0,2.83,0l51.12-51.12a2,2,0,0,0,0-2.83Zm-1.64,4.43,6.32,6.29-48.2,48.2-6.27-6.23Zm9.15,9.11,2.88,2.87-48.19,48.19-2.89-2.87Zm-24.73,71.47L179,213.19,227.2,165l17.71,17.63Z"
          />
          <rect
            className={styles.credit_card_cls_1}
            x="190.05"
            y="209.02"
            width="28.95"
            height="4"
            rx="2"
            ry="2"
            transform="translate(-89.31 206.42) rotate(-45)"
          />
          <rect
            className={styles.credit_card_cls_1}
            x="191.58"
            y="202.05"
            width="4"
            height="15.32"
            rx="2"
            ry="2"
            transform="translate(204.98 -75.46) rotate(45)"
          />
          <rect
            className={styles.credit_card_cls_2}
            x="158.23"
            y="221.41"
            width="15.83"
            height="4"
            rx="2"
            ry="2"
            transform="translate(-109.31 182.92) rotate(-45)"
          />
          <rect
            className={styles.credit_card_cls_2}
            x="163.35"
            y="229.61"
            width="4"
            height="15.32"
            rx="2"
            ry="2"
            transform="translate(216.21 -47.42) rotate(45)"
          />
          <rect
            className={styles.credit_card_cls_2}
            x="154.13"
            y="207.24"
            width="4"
            height="26.23"
            rx="2"
            ry="2"
            transform="translate(201.54 -45.86) rotate(45)"
          />
          <rect
            className={styles.credit_card_cls_2}
            x="221.07"
            y="174.35"
            width="12.67"
            height="15.32"
            rx="2"
            ry="2"
            transform="translate(195.31 -107.48) rotate(45)"
          />
        </g>
      </svg>
    );
  }

  if (icon === "edit") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22.71 24.73"
      >
        <path
          d="M30.06,16.58a1,1,0,0,0-1.41,0L17.08,28l-.08.1V28l-1.8-1.75,9-8.89a1,1,0,0,0,0-1.39h0a1,1,0,0,0-1.39,0l-9,8.89L12,23l.09-.1L25.84,9.35a1,1,0,0,0-1.41-1.42h0L10.67,21.53a7.75,7.75,0,0,0-2.15,3.94l-.83,4a2.4,2.4,0,0,0,2.82,2.85l4-.78a7.76,7.76,0,0,0,4-2.1L30,18a1,1,0,0,0,0-1.41Zm-15.93,13-4,.78a.41.41,0,0,1-.48-.48l.83-4a5.77,5.77,0,0,1,.37-1.11l4.39,4.44a5.76,5.76,0,0,1-1.11.35Z"
          transform="translate(-7.64 -7.64)"
        />
      </svg>
    );
  }

  if (icon === "tick") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19.02 14.73"
      >
        <path
          d="M27.47,12.83h0a1,1,0,0,0-1.39,0l-12.31,12L10.4,21.45a1,1,0,0,0-1.39,0H9a1,1,0,0,0,0,1.39L13.06,27a1,1,0,0,0,1.39,0h0v-.06l13-12.72A1,1,0,0,0,27.47,12.83Z"
          transform="translate(-8.73 -12.55)"
        />
      </svg>
    );
  }

  // ARROWS

  if (icon === "up") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15.4 8.1"
      >
        <path
          d="M20.1,15.9a2.46,2.46,0,0,1,1.7.8l5.7,5.6a1,1,0,0,1-1.4,1.4l-5.7-5.6c-.2-.2-.4-.2-.7,0l-5.6,5.6a1,1,0,0,1-1.4-1.4l5.6-5.6A2.44,2.44,0,0,1,20.1,15.9Z"
          transform="translate(-12.4 -15.9)"
        />
      </svg>
    );
  }

  if (icon === "down") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15.4 8.1"
      >
        <path
          d="M20.1,24a2.46,2.46,0,0,1-1.7-.8l-5.7-5.6a1,1,0,0,1,1.4-1.4l5.7,5.6c.2.2.4.2.7,0l5.6-5.6a1,1,0,0,1,1.4,1.4l-5.6,5.6A2.44,2.44,0,0,1,20.1,24Z"
          transform="translate(-12.4 -15.9)"
        />
      </svg>
    );
  }

  if (icon === "left") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 8.1 15.4"
      >
        <path
          d="M16,20.1a2.46,2.46,0,0,1,.8-1.7l5.6-5.7a1,1,0,0,1,1.4,1.4l-5.6,5.7c-.2.2-.2.4,0,.7l5.6,5.6a1,1,0,0,1-1.4,1.4l-5.6-5.6A2.44,2.44,0,0,1,16,20.1Z"
          transform="translate(-16 -12.4)"
        />
      </svg>
    );
  }

  if (icon === "right") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 8.15 15.46"
      >
        <path
          d="M24,19.92a2.46,2.46,0,0,1-.76,1.74l-5.57,5.72A1,1,0,1,1,16.26,26l5.58-5.73a.41.41,0,0,0,0-.67L16.27,14a1,1,0,0,1,1.41-1.41l5.58,5.58A2.46,2.46,0,0,1,24,19.92Z"
          transform="translate(-15.85 -12.35)"
        />
      </svg>
    );
  }

  // MISC

  if (icon === "save") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
      >
        <path
          d="M22.34,8h-13C8.23,8,8,8.35,8,9.47V30.19C8,31.32,8.75,33,10.36,33H30.08c2.09,0,2.92-.42,2.92-2.81v-13C33,11.82,27.73,8,22.34,8ZM15,10h6v6H15Zm0,21V22H26v9Zm16,0H28V21c0-1.12-1.86-1-3-1H14.37C13.24,20,13,19.83,13,21V31H10V10h3v4.88C13,16,13.2,18,14.32,18h6.35C21.79,18,23,16,23,14.88V9.49c4,.19,8,3.57,8,7.72Z"
          transform="translate(-8 -8)"
        />
      </svg>
    );
  }

  if (icon === "settings") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25.88 25.84"
      >
        <path
          d="M22.07,34.11H17.93a.65.65,0,0,1-.65-.65h0V30.4a9.44,9.44,0,0,1-1.86-.79l-2.18,2.18a.65.65,0,0,1-.92,0h0L9.4,28.87a.65.65,0,0,1,0-.92h0l2.22-2.22A9.43,9.43,0,0,1,10.91,24H7.73a.65.65,0,0,1-.65-.65v-4.2a.65.65,0,0,1,.65-.65h3.22a9.5,9.5,0,0,1,.71-1.69l-2.3-2.3a.65.65,0,0,1,0-.92h0l3-3a.65.65,0,0,1,.92,0h0l2.3,2.3a9.45,9.45,0,0,1,1.73-.72V8.92A.65.65,0,0,1,18,8.27H22.1a.65.65,0,0,1,.65.65v3.22a9.46,9.46,0,0,1,1.77.72l2.27-2.27a.65.65,0,0,1,.92,0h0l2.93,2.93a.65.65,0,0,1,0,.92h0l-2.22,2.22a9.47,9.47,0,0,1,.77,1.81h3.12a.65.65,0,0,1,.65.65h0v4.2a.65.65,0,0,1-.65.65H29.19a9.43,9.43,0,0,1-.75,1.81l2.16,2.16a.65.65,0,0,1,0,.92h0l-3,3a.65.65,0,0,1-.92,0h0L24.52,29.7a9.47,9.47,0,0,1-1.83.75v3A.65.65,0,0,1,22.07,34.11Zm-3.42-1.84h2.7V29.52a.63.63,0,0,1,.5-.61A7.79,7.79,0,0,0,24.11,28a.63.63,0,0,1,.78.08l2,2,2-2-2-2a.63.63,0,0,1-.08-.78,7.77,7.77,0,0,0,.92-2.24.63.63,0,0,1,.61-.5h2.8V19.84H28.25a.63.63,0,0,1-.61-.49,7.79,7.79,0,0,0-1-2.23.63.63,0,0,1,.08-.79l2-2L26.88,12.4l-2,2.06a.63.63,0,0,1-.78.08,7.77,7.77,0,0,0-2.2-.89.63.63,0,0,1-.5-.61V10.11h-2.7v3a.63.63,0,0,1-.49.61,7.78,7.78,0,0,0-2.17.9.63.63,0,0,1-.78-.08L13.12,12.4l-2,2,2.09,2.09a.63.63,0,0,1,.08.78,7.81,7.81,0,0,0-.89,2.13.63.63,0,0,1-.61.49H8.92V22.6H11.8a.63.63,0,0,1,.61.5,7.78,7.78,0,0,0,.89,2.19.63.63,0,0,1-.08.78l-2,2L13.12,30l2-2a.63.63,0,0,1,.79-.08,7.77,7.77,0,0,0,2.27,1,.63.63,0,0,1,.49.61Z"
          transform="translate(-7.08 -8.27)"
        />
        <path
          d="M21.21,25.49A4.47,4.47,0,0,1,15.7,20a4.4,4.4,0,0,1,3.09-3.09A4.47,4.47,0,0,1,24.3,22.4,4.4,4.4,0,0,1,21.21,25.49Zm-.65-7.13a2.88,2.88,0,1,0,2.26,2.26A2.88,2.88,0,0,0,20.56,18.36Z"
          transform="translate(-7.08 -8.27)"
        />
      </svg>
    );
  }

  if (icon === "close") {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15.28 14.9"
      >
        <path
          d="M21.67,20.21l-.18-.15a2.75,2.75,0,0,0,.33-.28L27.4,14.2A1,1,0,0,0,26,12.79l-5.58,5.58a.41.41,0,0,1-.67,0L14,12.78a1,1,0,0,0-1.39,1.43l5.72,5.57.18.15a2.75,2.75,0,0,0-.33.28L12.6,25.8A1,1,0,0,0,14,27.21l5.58-5.58a.41.41,0,0,1,.67,0L26,27.22a1,1,0,0,0,1.39-1.43Z"
          transform="translate(-12.36 -12.55)"
        />
      </svg>
    );
  }

  // PEOPLE COUNTER SLIDER

  if (icon === "person_1") {
    let person_1_val = 0;

    if (state == "person_1_complete") {
      person_1_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_1_val) }}>
        {value => (
          <svg
            className={styles.person_1}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.3 105.1"
          >
            <defs>
              <linearGradient
                id="person_1_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_1_gradient)">
              <path
                d="M45,67.3a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,1,1,.9-2.9,9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,1,1,1,2.8A12,12,0,0,1,45,67.3ZM47.5,58.8H44.9a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0v4.5h1.1A1.54,1.54,0,0,1,49,57.3a1.47,1.47,0,0,1-1.5,1.5h0ZM17.2,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-13.7,6.3-21.7,18.6-23.7A1.48,1.48,0,0,1,36,80.8a1.43,1.43,0,0,1-1.3,1.7h0C23.9,84.2,18.6,91,18.6,103.1v21.6a1.42,1.42,0,0,1-1.4,1.6h0ZM72.4,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-11.9-5.1-18.6-15.5-20.6a1.53,1.53,0,1,1,.6-3c11.7,2.2,18,10.3,18,23.5v21.6a1.52,1.52,0,0,1-1.6,1.6h0ZM26.8,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.47,1.47,0,0,1,26.8,132.1ZM62.2,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,62.2,132.1ZM45.1,84.4c-5.1,0-9-2.3-9-5.2V74.5a1.5,1.5,0,0,1,3,0v4.7c0,0.8,2.3,2.2,6,2.2s6-1.5,6-2.2V74.5a1.5,1.5,0,0,1,3,0v4.7C54,82.1,50.2,84.4,45.1,84.4ZM44.9,77.1A19.67,19.67,0,0,1,25.2,59.4a13.4,13.4,0,0,1-.1-2V47.8a1.5,1.5,0,0,1,3,0v9.6a9.7,9.7,0,0,0,.1,1.7,16.75,16.75,0,0,0,33.4-1.8v-13A14.11,14.11,0,0,0,47.4,30.2l-5.2-.1a16.52,16.52,0,0,0-4.4.5,1.52,1.52,0,1,1-.9-2.9,18.82,18.82,0,0,1,5.3-.7l5.2,0.1A17.09,17.09,0,0,1,64.5,44.2V57.1A19.66,19.66,0,0,1,44.9,77.1ZM25.2,58.8a4.4,4.4,0,0,1,0-8.8,1.54,1.54,0,0,1,1.5,1.5A1.47,1.47,0,0,1,25.2,53a1.4,1.4,0,0,0,0,2.8,1.54,1.54,0,0,1,1.5,1.5A1.47,1.47,0,0,1,25.2,58.8ZM64.5,58.8a1.5,1.5,0,0,1,0-3,1.4,1.4,0,1,0,0-2.8,1.5,1.5,0,0,1,0-3A4.4,4.4,0,1,1,64.5,58.8ZM45.1,96.2a3.9,3.9,0,0,1-3.9-3.9,3.9,3.9,0,0,1,7.8,0h0A4,4,0,0,1,45.1,96.2Zm0-4.8a0.9,0.9,0,1,0,.9.9h0a1.06,1.06,0,0,0-.9-0.9h0ZM45.1,123.8a1.34,1.34,0,0,1-1.3-.8l-2.4-5a1.13,1.13,0,0,1-.1-0.8l2.4-21.5a1.49,1.49,0,0,1,1.4-1.3h0a1.51,1.51,0,0,1,1.5,1.3L49,117.2a2,2,0,0,1-.1.8l-2.4,5A2.25,2.25,0,0,1,45.1,123.8ZM44.2,117l0.8,1.8,0.8-1.8-0.9-7.7ZM27.8,49.2a4.65,4.65,0,0,1-2.3-.6A4.76,4.76,0,0,1,23,44.4c0-8.2,7.4-15.1,14.2-16.7a1.49,1.49,0,0,1,.7,2.9h0C32.2,31.9,26.1,37.9,26,44.4a1.86,1.86,0,0,0,.9,1.5,1.91,1.91,0,0,0,1.8,0A31.17,31.17,0,0,0,34,41.6l0.8-.7c3.3-3.1,6.2-.6,7.7.7a5.72,5.72,0,0,0,1.6,1.1c1.3,0.1,3-1.5,4.5-2.9,1.8-1.7,3.6-3.3,5.6-3.2A4.2,4.2,0,0,1,56.9,38a1.48,1.48,0,0,1-2.1,2.1L54.7,40a0.71,0.71,0,0,0-.6-0.4c-0.8-.1-2.3,1.3-3.4,2.4-1.9,2-4.2,4-6.7,3.8a5.83,5.83,0,0,1-3.4-1.9c-1.8-1.6-2.5-1.9-3.7-.8l-0.8.7a36.64,36.64,0,0,1-5.8,4.6A3.75,3.75,0,0,1,27.8,49.2ZM49.1,93.7h0a1.43,1.43,0,0,1-1.2-.6c-0.4-.5-3.6-4.8-4.3-7.1a1.46,1.46,0,1,1,2.8-.8,21.34,21.34,0,0,0,2.7,4.6c2.8-3.4,5.2-7.2,5.1-8.8a14.31,14.31,0,0,0-1.5,1.1,1.55,1.55,0,0,1-2.1-.3,1.51,1.51,0,0,1,.1-1.9,23.07,23.07,0,0,1,1.9-1.4,2.64,2.64,0,0,1,2.3-.9,3,3,0,0,1,2,2.2c1.3,3.9-4.9,11.3-6.8,13.5A1.53,1.53,0,0,1,49.1,93.7ZM41,93.7a1.61,1.61,0,0,1-1.1-.5C38,91,31.8,83.6,33.1,79.7a2.82,2.82,0,0,1,2-2.2,2.72,2.72,0,0,1,2.4.9l1.7,1.2A1.5,1.5,0,0,1,37.4,82l-1.5-1c0,1.6,2.4,5.5,5.1,8.8a21.34,21.34,0,0,0,2.7-4.6,1.49,1.49,0,1,1,2.9.7V86c-0.7,2.4-3.9,6.6-4.3,7.1a1.76,1.76,0,0,1-1.3.6h0Z"
                transform="translate(-15.7 -27)"
              />
              <circle cx="22" cy="24.4" r="1.8" />
              <circle cx="36.7" cy="24.4" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_2") {
    let person_2_val = 0;

    if (state == "person_2_complete") {
      person_2_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_2_val) }}>
        {value => (
          <svg
            className={styles.person_2}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.3 104.9"
          >
            <defs>
              <linearGradient
                id="person_2_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_2_gradient)">
              <path
                d="M121.1,102.7h-7.6a1.5,1.5,0,1,1,0-3h7.6A1.5,1.5,0,1,1,121.1,102.7ZM121.1,111.2h-7.6a1.5,1.5,0,0,1,0-3h7.6A1.5,1.5,0,0,1,121.1,111.2ZM121.1,119.8h-7.6a1.5,1.5,0,0,1,0-3h7.6A1.5,1.5,0,0,1,121.1,119.8ZM117.4,67.3a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,1,1,.9-2.9,10.42,10.42,0,0,0,6.3,0,1.49,1.49,0,0,1,1,2.8A14.78,14.78,0,0,1,117.4,67.3ZM120,58.8h-2.6a1.54,1.54,0,0,1-1.5-1.5h0v-6a1.5,1.5,0,0,1,3,0v4.5H120a1.5,1.5,0,0,1,0,3h0ZM89.6,126.2a1.54,1.54,0,0,1-1.5-1.5V103.1c0-14.7,7.1-22.7,21.2-24a1.5,1.5,0,0,1,.2,3c-12.4,1.1-18.4,8-18.4,21v21.6a1.47,1.47,0,0,1-1.5,1.5h0ZM144.9,126.2a1.54,1.54,0,0,1-1.5-1.5V103.1c0-13-6.1-19.9-18.6-21a1.5,1.5,0,0,1,.2-3c14,1.2,21.4,9.5,21.4,24v21.6A1.54,1.54,0,0,1,144.9,126.2ZM100.6,132a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,0,1,3,0v29.4A1.52,1.52,0,0,1,100.6,132ZM134.9,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,134.9,132.1ZM117.2,91.7a1.69,1.69,0,0,1-1-.3c-2.3-1.9-7.7-6.7-7.7-9.4V74.5a1.5,1.5,0,0,1,3,0V82c0.1,0.9,2.7,3.7,5.7,6.3,3.3-2.6,6.1-5.4,6.3-6.3V74.5a1.5,1.5,0,0,1,3,0V82c0,2.7-5.3,7.1-8.4,9.4A3.18,3.18,0,0,1,117.2,91.7ZM117.4,77A19.85,19.85,0,0,1,97.6,57.2V44.3a17.11,17.11,0,0,1,17.2-17.1h5.3a17.09,17.09,0,0,1,17.1,17.1V57.2A19.91,19.91,0,0,1,117.4,77Zm-2.7-46.9a14.23,14.23,0,0,0-14.2,14.1V57.1a16.77,16.77,0,0,0,16.8,16.8h0a16.77,16.77,0,0,0,16.8-16.8v-13A14.08,14.08,0,0,0,120,30ZM126.2,82.3h0a1.56,1.56,0,0,1-1.6-1.5,1.54,1.54,0,0,1,1.5-1.5h0.1c3.8,0,6.6-1.3,8.5-3.9,7-9.6-.8-33.4-0.9-33.6a1.52,1.52,0,1,1,2.9-.9c0.3,1,8.3,25.5.4,36.3C134.7,80.6,131,82.3,126.2,82.3ZM108.6,82.3c-4.8,0-8.5-1.7-11-5.1-7.9-10.8.1-35.3,0.4-36.3a1.52,1.52,0,1,1,2.9.9h0c-0.1.2-7.8,24-.8,33.6,1.9,2.6,4.7,3.8,8.6,3.9h0a1.54,1.54,0,0,1,1.5,1.5,1.56,1.56,0,0,1-1.6,1.5h0ZM135.1,45.6H120a1.69,1.69,0,0,1-1.4-.9l-1-2.3-1,2.3a1.57,1.57,0,0,1-1.4.9H99.7a1.5,1.5,0,0,1,0-3h14.5l2-4.6a1.51,1.51,0,0,1,2-.8,2,2,0,0,1,.8.8l2,4.6h14.1A1.5,1.5,0,0,1,135.1,45.6ZM117.2,123.8a1.54,1.54,0,0,1-1.5-1.5V90.2a1.5,1.5,0,1,1,3,0v32.1A1.61,1.61,0,0,1,117.2,123.8Z"
                transform="translate(-88.1 -27.2)"
              />
              <circle cx="22.1" cy="24.2" r="1.8" />
              <circle cx="36.7" cy="24.2" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_3") {
    let person_3_val = 0;

    if (state == "person_3_complete") {
      person_3_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_3_val) }}>
        {value => (
          <svg
            className={styles.person_3}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.51 104.8"
          >
            <defs>
              <linearGradient
                id="person_3_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_3_gradient)">
              <path
                d="M189.9,67.4a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,0,1,.9-2.9h0a9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,0,1,1,2.8h0A11.58,11.58,0,0,1,189.9,67.4ZM192.5,58.9h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0V56h1.1a1.54,1.54,0,0,1,1.5,1.5,1.39,1.39,0,0,1-1.5,1.4h0ZM162.1,126.2a1.54,1.54,0,0,1-1.5-1.5V103.2c0-13.5,6.1-21.4,18.2-23.5a1.65,1.65,0,0,1,1.8,1.2,1.56,1.56,0,0,1-1.2,1.8h0c-10.6,1.8-15.7,8.5-15.7,20.5v21.5A1.62,1.62,0,0,1,162.1,126.2ZM217.4,126.2a1.54,1.54,0,0,1-1.5-1.5V103.2c0-11.9-5.1-18.7-15.7-20.5a1.53,1.53,0,0,1,.6-3h0c11.9,2.1,18.2,10.2,18.2,23.5v21.5a1.63,1.63,0,0,1-1.6,1.5h0ZM173.1,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.47,1.47,0,0,1,173.1,132.1ZM207.4,132a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,0,1,3,0v29.4A1.52,1.52,0,0,1,207.4,132ZM189.8,85.2c-5,0-9-2.5-9-5.7V75a1.5,1.5,0,0,1,3,0v4.5c0,1.1,2.3,2.7,6,2.7s6-1.6,6-2.7V75a1.5,1.5,0,0,1,3,0v4.5C198.7,82.6,194.8,85.2,189.8,85.2ZM170.1,58.8a4.4,4.4,0,0,1,0-8.8h0a1.5,1.5,0,0,1,0,3,1.4,1.4,0,0,0,0,2.8h0A1.5,1.5,0,0,1,170.1,58.8ZM209.4,58.8a1.5,1.5,0,0,1,0-3,1.4,1.4,0,0,0,0-2.8,1.5,1.5,0,0,1,0-3,4.4,4.4,0,0,1,0,8.8h0ZM172.1,114.4a1.85,1.85,0,0,1-.7-0.2l-10-5a1.52,1.52,0,0,1,1.2-2.8,0.1,0.1,0,0,1,.1.1l10,5a1.63,1.63,0,0,1,.7,2A1.29,1.29,0,0,1,172.1,114.4ZM207.4,114.9a1.54,1.54,0,0,1-1.5-1.5,1.34,1.34,0,0,1,.8-1.3l10-5a1.48,1.48,0,1,1,1.4,2.6,0.1,0.1,0,0,0-.1.1l-10,5A1.08,1.08,0,0,1,207.4,114.9ZM193.8,93.7h0a1.43,1.43,0,0,1-1.2-.6c-0.4-.5-3.6-4.8-4.3-7.1a1.43,1.43,0,0,1,1-1.8,1.58,1.58,0,0,1,1.9,1,21.34,21.34,0,0,0,2.7,4.6c2.8-3.4,5.1-7.2,5.1-8.8a14.31,14.31,0,0,0-1.5,1.1,1.49,1.49,0,0,1-2.2-2,0.53,0.53,0,0,1,.3-0.2,23.07,23.07,0,0,1,1.9-1.4,2.72,2.72,0,0,1,2.4-.9,3,3,0,0,1,2,2.2c1.3,3.9-4.9,11.3-6.8,13.5A3.82,3.82,0,0,1,193.8,93.7ZM185.7,93.7a1.61,1.61,0,0,1-1.1-.5c-1.9-2.2-8.1-9.6-6.8-13.5a2.82,2.82,0,0,1,2-2.2,2.72,2.72,0,0,1,2.4.9l1.7,1.2a1.5,1.5,0,1,1-1.8,2.4h0l-1.6-1.2c-0.1,1.6,2.4,5.5,5.1,8.8a21.34,21.34,0,0,0,2.7-4.6,1.46,1.46,0,0,1,1.9-1,1.4,1.4,0,0,1,1,1.8c-0.7,2.4-3.9,6.6-4.3,7.1a1.16,1.16,0,0,1-1.2.8h0ZM189.8,84.8c-5,0-9-2.5-9-5.7V78.2a1.5,1.5,0,0,1,3,0v0.9c0,1.1,2.3,2.7,6,2.7s6-1.6,6-2.7V77.9a1.5,1.5,0,0,1,3,0v1.2C198.7,82.3,194.8,84.8,189.8,84.8ZM189.8,77.1A19.91,19.91,0,0,1,170,57.3V44.4a17.09,17.09,0,0,1,17.1-17.1h5.2a17.09,17.09,0,0,1,17.1,17.1V57.3A19.55,19.55,0,0,1,189.8,77.1Zm-2.7-46.8A14.11,14.11,0,0,0,173,44.5V57.4a16.8,16.8,0,0,0,33.6,0v-13a14.08,14.08,0,0,0-14.1-14.1h-5.4Z"
                transform="translate(-160.49 -27.3)"
              />
              <circle cx="22.21" cy="24.1" r="1.8" />
              <circle cx="36.81" cy="24.1" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_4") {
    let person_4_val = 0;

    if (state == "person_4_complete") {
      person_4_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_4_val) }}>
        {value => (
          <svg
            className={styles.person_4}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_4_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_4_gradient)">
              <path
                d="M262.5,67.4a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,0,1,.9-2.9,9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,0,1,1,2.8A12.34,12.34,0,0,1,262.5,67.4ZM265,58.9h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0V56H265a1.54,1.54,0,0,1,1.5,1.5,1.39,1.39,0,0,1-1.5,1.4h0ZM234.7,126.2a1.54,1.54,0,0,1-1.5-1.5V103.2c0-14.6,7.1-22.7,21.2-23.9a1.5,1.5,0,0,1,.2,3c-12.4,1.1-18.5,7.9-18.5,20.9v21.5A1.39,1.39,0,0,1,234.7,126.2ZM290,126.2a1.54,1.54,0,0,1-1.5-1.5V103.2c0-12.9-6.1-19.8-18.6-20.9a1.62,1.62,0,0,1-1.4-1.6,1.55,1.55,0,0,1,1.6-1.4c13.9,1.2,21.3,9.5,21.3,23.9v21.5A1.39,1.39,0,0,1,290,126.2ZM245.7,132a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,0,1,3,0v29.4A1.52,1.52,0,0,1,245.7,132ZM279.9,132a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,0,1,3,0v29.4A1.45,1.45,0,0,1,279.9,132ZM262.6,87.8c-5,0-9-2.5-9-5.7V74.6a1.5,1.5,0,1,1,3,0v7.5c0,1.1,2.3,2.7,6,2.7s6-1.6,6-2.7V74.6a1.5,1.5,0,1,1,3,0v7.5C271.5,85.3,267.6,87.8,262.6,87.8ZM262.4,77.2a19.85,19.85,0,0,1-19.8-19.8v-16a1.5,1.5,0,1,1,3,0v16a16.8,16.8,0,1,0,33.6,0v-14a1.5,1.5,0,1,1,3,0v14A19.91,19.91,0,0,1,262.4,77.2ZM270.5,103.3h-5.4a1.5,1.5,0,0,1,0-3h5.4a1.54,1.54,0,0,1,1.5,1.5A1.47,1.47,0,0,1,270.5,103.3ZM245.9,43.1a7.7,7.7,0,0,1-5.6-2.3,3.43,3.43,0,0,1-1.2-3,3.23,3.23,0,0,1,1.9-2.2,6.1,6.1,0,0,0,2.7-2.8,18.22,18.22,0,0,1,6.8-6.7c7.2-4.2,16.7-.6,17.8-0.2a1.5,1.5,0,0,1,1,1.4c0,0.6,0,6.4-.7,8.6-0.9,3.2-2.5,4.3-10.3,4.9a41.29,41.29,0,0,0-9.9,1.9A10.86,10.86,0,0,1,245.9,43.1Zm-3.8-4.8,0.3,0.3a5.25,5.25,0,0,0,5.2,1.2,48.35,48.35,0,0,1,10.6-2c7-.5,7.2-1.4,7.6-2.8a30.27,30.27,0,0,0,.5-6.7c-2.5-.8-9.3-2.6-14.3.3a15.12,15.12,0,0,0-5.8,5.7,8.66,8.66,0,0,1-3.9,3.9ZM281.1,43.5c-2.9,0-9.9-3.5-11.2-4.3-3.3-2.1-3.2-10.3-3.1-11.9a1.4,1.4,0,0,1,1.2-1.4c0.3,0,6.9-1.2,11.2,2.5,2.6,2.3,4.7,8.9,4.3,12.2a3.15,3.15,0,0,1-1.6,2.7A1.88,1.88,0,0,1,281.1,43.5Zm0-3h0ZM269.8,28.6c0,3.5.6,7.3,1.7,8a41.92,41.92,0,0,0,9,3.8c0.4-1.8-1.2-8-3.3-9.8C275,28.6,271.6,28.5,269.8,28.6ZM242.7,58.8a4.4,4.4,0,0,1,0-8.8h0a1.5,1.5,0,1,1,0,3h0a1.4,1.4,0,0,0,0,2.8h0a1.5,1.5,0,0,1,0,3h0ZM282,58.8a1.5,1.5,0,0,1,0-3,1.4,1.4,0,0,0,0-2.8,1.5,1.5,0,0,1,0-3,4.44,4.44,0,0,1,4.4,4.4,4.51,4.51,0,0,1-4.4,4.4h0Z"
                transform="translate(-233.2 -24.08)"
              />
              <circle cx="22.1" cy="27.32" r="1.8" />
              <circle cx="36.7" cy="27.32" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_5") {
    let person_5_val = 0;

    if (state == "person_5_complete") {
      person_5_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_5_val) }}>
        {value => (
          <svg
            className={styles.person_5}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_5_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_5_gradient)">
              <path
                d="M335.5,67.4a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,0,1,.9-2.9,9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,0,1,1,2.8A11.58,11.58,0,0,1,335.5,67.4ZM338.1,58.9h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0V56h1.1a1.54,1.54,0,0,1,1.5,1.5,1.39,1.39,0,0,1-1.5,1.4h0ZM307.7,126.2a1.54,1.54,0,0,1-1.5-1.5V103.2c0-14.6,7.1-22.6,21.1-23.8a1.5,1.5,0,0,1,.2,3h0c-12.4,1.1-18.4,7.9-18.4,20.8v21.5A1.34,1.34,0,0,1,307.7,126.2ZM363,126.2a1.54,1.54,0,0,1-1.5-1.5V103.2c0-12.9-6-19.7-18.5-20.9a1.5,1.5,0,0,1,.2-3h0c13.9,1.2,21.2,9.5,21.2,23.8v21.5a1.42,1.42,0,0,1-1.4,1.6h0ZM318.8,132a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,0,1,3,0v29.4A1.52,1.52,0,0,1,318.8,132ZM353,132a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,0,1,3,0v29.4A1.45,1.45,0,0,1,353,132ZM335.6,87.8c-5,0-9-2.5-9-5.7V74.6a1.5,1.5,0,1,1,3,0v7.5c0,1.1,2.3,2.7,6,2.7s6-1.6,6-2.7V74.6a1.5,1.5,0,1,1,3,0v7.5C344.6,85.3,340.7,87.8,335.6,87.8ZM335.5,77.2a19.85,19.85,0,0,1-19.8-19.8V46.5a1.5,1.5,0,0,1,3,0V57.4a16.8,16.8,0,1,0,33.6,0V46.5a1.5,1.5,0,0,1,3,0V57.4A20,20,0,0,1,335.5,77.2ZM335.6,125.8a1.56,1.56,0,0,1-1.3-.8l-11-19.6a1.71,1.71,0,0,1,0-1.4l3.2-6.2-5.9-4.7a1.53,1.53,0,0,1-.4-1.8l4.7-10.7a1.51,1.51,0,0,1,2-.8,1.67,1.67,0,0,1,.9,1.1l9.2,43a1.49,1.49,0,0,1-1.1,1.8,0.37,0.37,0,0,1-.3.1h0Zm-9.3-21.1,5.7,10.2-3.2-15Zm-2.8-13.2,4.3,3.5-1.9-8.9ZM336.4,125.8a1.54,1.54,0,0,1-1.5-1.5V124l9.2-43a1.65,1.65,0,0,1,1.8-1.2,1.44,1.44,0,0,1,1.1.9l4.8,10.7a1.53,1.53,0,0,1-.4,1.8l-5.9,4.7,3.2,6.2a1.71,1.71,0,0,1,0,1.4l-11,19.6A1.71,1.71,0,0,1,336.4,125.8Zm6.8-25.9-3.2,15,5.7-10.2Zm3-13.8-2,8.9,4.3-3.5ZM344.4,28.3a1.54,1.54,0,0,1-1.5-1.5,7.5,7.5,0,1,0-15,0,1.5,1.5,0,0,1-3,0,10.5,10.5,0,1,1,21,0A1.54,1.54,0,0,1,344.4,28.3ZM319,47.1a4.3,4.3,0,0,1-2.7-.8c-1.2-.9-1.8-2.5-1.8-4.9,0-9.8,9.4-17.7,20.9-17.7s20.9,7.9,20.9,17.7c0,2.4-.6,4-1.8,4.9-2,1.5-5,.6-8.6-0.5a28,28,0,0,0-20.9,0A21.53,21.53,0,0,1,319,47.1Zm16.4-6.3A40.41,40.41,0,0,1,346.7,43c2.5,0.8,5.2,1.6,6,1,0.4-.3.6-1.2,0.6-2.5,0-8.1-8-14.7-17.9-14.7s-17.9,6.6-17.9,14.7c0,1.3.2,2.2,0.6,2.5,0.8,0.6,3.5-.2,6-1a39.06,39.06,0,0,1,11.3-2.2h0ZM328.6,43.4a1.54,1.54,0,0,1-1.5-1.5v-1a29.55,29.55,0,0,1,1.1-7.9l0.1-.4a1.49,1.49,0,1,1,2.9.7v0.1l-0.1.4a24.57,24.57,0,0,0-1,7.2v1A1.52,1.52,0,0,1,328.6,43.4ZM341.9,43.4a1.54,1.54,0,0,1-1.5-1.5v-1a25.53,25.53,0,0,0-1-7.2l-0.1-.4a1.52,1.52,0,1,1,2.9-.9v0.1l0.1,0.4a30.71,30.71,0,0,1,1.1,7.9v1A1.56,1.56,0,0,1,341.9,43.4ZM315.8,58.6a4.4,4.4,0,0,1,0-8.8,1.5,1.5,0,0,1,0,3,1.4,1.4,0,0,0,0,2.8A1.5,1.5,0,0,1,315.8,58.6ZM355.1,58.6a1.5,1.5,0,0,1,0-3,1.4,1.4,0,0,0,0-2.8,1.5,1.5,0,0,1,0-3,4.44,4.44,0,0,1,4.4,4.4,4.51,4.51,0,0,1-4.4,4.4h0Z"
                transform="translate(-306.2 -16.3)"
              />
              <circle cx="22.1" cy="35.1" r="1.8" />
              <circle cx="36.7" cy="35.1" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_6") {
    let person_6_val = 0;

    if (state == "person_6_complete") {
      person_6_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_6_val) }}>
        {value => (
          <svg
            className={styles.person_6}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_6_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_6_gradient)">
              <path
                d="M386.8,58.6a4.4,4.4,0,0,1,0-8.8h0a1.5,1.5,0,0,1,0,3,1.4,1.4,0,0,0,0,2.8h0A1.5,1.5,0,0,1,386.8,58.6ZM426.1,58.6a1.5,1.5,0,0,1,0-3,1.4,1.4,0,0,0,0-2.8,1.5,1.5,0,0,1,0-3,4.44,4.44,0,0,1,4.4,4.4,4.51,4.51,0,0,1-4.4,4.4h0ZM406.5,67.3a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,0,1,.9-2.9,9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,0,1,1,2.8A12.34,12.34,0,0,1,406.5,67.3ZM409,58.8h-2.6a1.54,1.54,0,0,1-1.5-1.5h0v-6a1.5,1.5,0,1,1,3,0v4.5H409a1.5,1.5,0,0,1,0,3h0ZM378.1,126.1a1.54,1.54,0,0,1-1.5-1.5V102.3c0-15.1,7.3-23.4,21.8-24.7a1.5,1.5,0,0,1,.2,3h0c-12.8,1.1-19,8.2-19,21.7v22.3a1.47,1.47,0,0,1-1.5,1.5h0ZM434.5,126.1a1.54,1.54,0,0,1-1.5-1.5V102.3c0-12.9-5.7-19.9-17.4-21.5a1.51,1.51,0,0,1,.4-3c13.1,1.8,20,10.2,20,24.4v22.3a1.44,1.44,0,0,1-1.5,1.6h0ZM389.7,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,389.7,132.1ZM422.9,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.47,1.47,0,0,1,422.9,132.1ZM406.6,84.7c-5,0-9-2.5-9-5.7V74.5a1.5,1.5,0,0,1,3,0V79c0,1.1,2.3,2.7,6,2.7s6-1.6,6-2.7V74.4a1.5,1.5,0,0,1,3,0V79C415.5,82.2,411.6,84.7,406.6,84.7ZM406.4,77a19.85,19.85,0,0,1-19.8-19.8V43.7a1.67,1.67,0,0,1,.1-1.2,17.22,17.22,0,0,1,17.1-15.4l5,0.2h0c8.9,0,19.4,7.5,19.4,17.1a4.44,4.44,0,0,1-2,3.8v9A19.78,19.78,0,0,1,406.4,77ZM389.7,43.9V57.2a16.8,16.8,0,1,0,33.6,0V49.1a4.76,4.76,0,0,1-2.3-.7l-13-6.3c-1.8,2-6.1,1.7-10.2,1.4C395,43.3,391.2,43.1,389.7,43.9Zm17.7-5.3a1.85,1.85,0,0,1,.7.2l14.3,7.1,0.1,0.1a1.91,1.91,0,0,0,1.8,0,1.65,1.65,0,0,0,.9-1.5c0-6.5-7.2-14.1-16.5-14.1l-5-.2a14.13,14.13,0,0,0-13.6,10.4,34.79,34.79,0,0,1,7.9-.1c2.9,0.2,7.6.5,7.9-.7a1.43,1.43,0,0,1,1.5-1.2h0ZM410.6,93.7h0a1.43,1.43,0,0,1-1.2-.6c-0.4-.5-3.6-4.8-4.3-7.1a1.58,1.58,0,0,1,1-1.9,1.5,1.5,0,0,1,1.9,1,21.34,21.34,0,0,0,2.7,4.6c2.8-3.4,5.1-7.2,5.1-8.8a14.31,14.31,0,0,0-1.5,1.1,1.55,1.55,0,0,1-2.1-.3,1.51,1.51,0,0,1,.1-1.9,23.07,23.07,0,0,1,1.9-1.4,2.72,2.72,0,0,1,2.4-.9,3,3,0,0,1,2,2.2c1.3,3.9-4.9,11.3-6.8,13.5A2.08,2.08,0,0,1,410.6,93.7ZM402.5,93.7a1.61,1.61,0,0,1-1.1-.5c-1.9-2.2-8.1-9.6-6.8-13.5a2.82,2.82,0,0,1,2-2.2,2.72,2.72,0,0,1,2.4.9l1.7,1.2a1.45,1.45,0,0,1,0,2.1,1.36,1.36,0,0,1-1.7.3l-1.6-1.2c-0.1,1.6,2.3,5.4,5.1,8.8a21.34,21.34,0,0,0,2.7-4.6,1.46,1.46,0,0,1,1.9-1,1.5,1.5,0,0,1,1,1.9h0c-0.7,2.4-3.9,6.6-4.3,7.1a1.86,1.86,0,0,1-1.3.7h0Z"
                transform="translate(-376.6 -27.1)"
              />
              <circle cx="22.6" cy="24.3" r="1.8" />
              <circle cx="37.3" cy="24.3" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_7") {
    let person_7_val = 0;

    if (state == "person_7_complete") {
      person_7_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_7_val) }}>
        {value => (
          <svg
            className={styles.person_7}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_7_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_7_gradient)">
              <path
                d="M479,67.3a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,0,1,.9-2.9,10.42,10.42,0,0,0,6.3,0,1.49,1.49,0,0,1,1,2.8A12,12,0,0,1,479,67.3ZM481.5,58.8h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0v4.5h1.1a1.54,1.54,0,0,1,1.5,1.5,1.47,1.47,0,0,1-1.5,1.5h0ZM451.2,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-14.7,7.2-22.8,21.4-24a1.5,1.5,0,0,1,.2,3c-12.5,1-18.6,7.9-18.6,21v21.6A1.54,1.54,0,0,1,451.2,126.3ZM506.4,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-12.6-5.7-19.4-17.4-20.8a1.51,1.51,0,0,1,.4-3c13.1,1.6,20,9.8,20,23.8v21.6A1.54,1.54,0,0,1,506.4,126.3ZM462.2,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,462.2,132.1ZM496.4,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,496.4,132.1ZM478.7,91.7a1.69,1.69,0,0,1-1-.3c-2.3-1.9-7.7-6.7-7.7-9.4V74.5a1.5,1.5,0,1,1,3,0V82c0.1,0.9,2.7,3.7,5.7,6.3,3.3-2.6,6.1-5.4,6.3-6.3V74.5a1.5,1.5,0,0,1,3,0V82c0,2.7-5.3,7.1-8.4,9.4A1.61,1.61,0,0,1,478.7,91.7ZM478.9,77a19.85,19.85,0,0,1-19.8-19.8V44.3a17.09,17.09,0,0,1,17.1-17.1h5.2a17.09,17.09,0,0,1,17.1,17.1V57.2A19.55,19.55,0,0,1,478.9,77Zm-2.6-46.9a14.11,14.11,0,0,0-14.1,14.2v13a16.8,16.8,0,1,0,33.6,0v-13a14.08,14.08,0,0,0-14.1-14.1ZM461.2,109a1.85,1.85,0,0,1-.7-0.2l-10-5a1.49,1.49,0,0,1-.6-2,1.46,1.46,0,0,1,1.9-.6l10,5a1.63,1.63,0,0,1,.7,2,1.34,1.34,0,0,1-1.3.8h0ZM496.4,109.6a1.54,1.54,0,0,1-1.5-1.5,1.34,1.34,0,0,1,.8-1.3l10-5a1.54,1.54,0,0,1,2,.8,1.57,1.57,0,0,1-.6,1.9l-10,5C496.9,109.5,496.7,109.6,496.4,109.6ZM476.3,101.6a1.71,1.71,0,0,1-1.3-.7L463.2,82.7a1.6,1.6,0,0,1,.5-2.1,1.53,1.53,0,0,1,2,.4l9.9,15.2,1.6-6.5a1.53,1.53,0,0,1,3,.6v0.1l-2.4,9.9a1.38,1.38,0,0,1-1.2,1.1ZM482.7,101.6h-0.1a1.7,1.7,0,0,1-1.3-1l-3.6-9.9a1.5,1.5,0,0,1,2.7-1.3c0,0.1.1,0.2,0.1,0.3l2.6,7,9.3-15.1a1.53,1.53,0,0,1,2.6,1.6L484.1,101A2.51,2.51,0,0,1,482.7,101.6ZM455,87.6h-0.2a1.55,1.55,0,0,1-1.3-1.7h0a3.91,3.91,0,0,0-.4-2.6,7.51,7.51,0,0,1,1.2-8.1,4.58,4.58,0,0,0,.7-5,7.51,7.51,0,0,1,1.2-8.1,4.58,4.58,0,0,0,.7-5,7.51,7.51,0,0,1,1.2-8.1,4.42,4.42,0,0,0,1.1-2.4,1.51,1.51,0,1,1,3,.4,7.38,7.38,0,0,1-1.8,3.9,4.58,4.58,0,0,0-.7,5,7.51,7.51,0,0,1-1.2,8.1,4.58,4.58,0,0,0-.7,5,7.51,7.51,0,0,1-1.2,8.1,4.58,4.58,0,0,0-.7,5,7.59,7.59,0,0,1,.6,4.2A1.37,1.37,0,0,1,455,87.6ZM502.9,87.9a1.5,1.5,0,0,1-1.5-1.3,6.16,6.16,0,0,1,.6-4.2,4.4,4.4,0,0,0-.8-5,7.53,7.53,0,0,1-1.3-8.1,4.4,4.4,0,0,0-.8-5,7.53,7.53,0,0,1-1.3-8.1,4.4,4.4,0,0,0-.8-5,7.08,7.08,0,0,1-1.8-3.8,1.48,1.48,0,0,1,1.3-1.7,1.43,1.43,0,0,1,1.7,1.3,4,4,0,0,0,1.2,2.4,7.53,7.53,0,0,1,1.3,8.1,4.4,4.4,0,0,0,.8,5,7.53,7.53,0,0,1,1.3,8.1,4.4,4.4,0,0,0,.8,5,7.53,7.53,0,0,1,1.3,8.1,4.62,4.62,0,0,0-.4,2.6,1.48,1.48,0,0,1-1.2,1.7h-0.4V87.9ZM463.9,48.5a21.75,21.75,0,0,1-2.5-.1,1.5,1.5,0,0,1-1.3-1.7,1.43,1.43,0,0,1,1.7-1.3c6.5,0.7,12.3-1.6,17.3-6.7a30.59,30.59,0,0,0,5.6-8.2,1.52,1.52,0,1,1,2.8,1.2,32.51,32.51,0,0,1-6.1,9C476.3,45.8,470.3,48.5,463.9,48.5ZM497,49.2c-5.8,0-9.7-13.2-10.8-17.3a1.49,1.49,0,1,1,2.9-.7c1.9,7.3,5.5,15,7.9,15h0.1a1.5,1.5,0,0,1,.2,3H497Z"
                transform="translate(-449.7 -27.2)"
              />
              <circle cx="22" cy="24.2" r="1.8" />
              <circle cx="36.7" cy="24.2" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_8") {
    let person_8_val = 0;

    if (state == "person_8_complete") {
      person_8_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_8_val) }}>
        {value => (
          <svg
            className={styles.person_8}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_8_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_8_gradient)">
              <path
                d="M554,67.4a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,1,1,.9-2.9,9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,1,1,1,2.8A12,12,0,0,1,554,67.4ZM556.5,58.9h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,1,1,3,0V56h1.1a1.54,1.54,0,0,1,1.5,1.5,1.39,1.39,0,0,1-1.5,1.4h0ZM526.2,126.3a1.54,1.54,0,0,1-1.5-1.5V103.3c0-14.7,7.2-22.7,21.2-23.9a1.5,1.5,0,1,1,.2,3h0c-12.5,1.1-18.5,7.9-18.5,20.9v21.6A1.36,1.36,0,0,1,526.2,126.3ZM581.5,126.3a1.54,1.54,0,0,1-1.5-1.5V103.3c0-12.9-6-19.7-18.2-20.9a1.5,1.5,0,1,1,.2-3c13.7,1.3,21,9.6,21,23.9v21.6a1.52,1.52,0,0,1-1.5,1.4h0ZM537.2,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,537.2,132.1ZM571.4,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.47,1.47,0,0,1,571.4,132.1ZM568.6,47.4c-16,0-29.2-12-29.8-12.5a1.54,1.54,0,0,1,.1-2.1,1.5,1.5,0,0,1,1.9-.1c0.1,0.1,14.6,13.2,30.7,11.6a1.56,1.56,0,0,1,1.7,1.4,1.42,1.42,0,0,1-1.4,1.6C570.7,47.4,569.7,47.4,568.6,47.4ZM582.2,68.4H569.5a1.5,1.5,0,0,1,0-3H580l-9.8-24.8a1.55,1.55,0,0,1,2.9-1.1l10.6,26.8a1.48,1.48,0,0,1-.8,1.9,1.08,1.08,0,0,1-.7.2h0ZM538.2,68.4H525.5a1.54,1.54,0,0,1-1.5-1.5,0.75,0.75,0,0,1,.1-0.5l10.6-26.8a1.51,1.51,0,0,1,2-.8,1.43,1.43,0,0,1,.8,1.9l-9.8,24.8h10.5a1.54,1.54,0,0,1,1.5,1.5,1.39,1.39,0,0,1-1.5,1.4h0ZM553.6,99.1h-0.9c-10.4-.8-16.6-14.2-16.9-14.8a1.5,1.5,0,0,1,2.7-1.3c0.1,0.1,5.7,12.4,14.4,13,5.6,0.4,11.4-4,17.3-13.2a1.48,1.48,0,1,1,2.6,1.4l-0.1.1C566.5,94.2,560.1,99.1,553.6,99.1ZM554,91.6h-0.4a9,9,0,0,1-7.1-4.1,6.36,6.36,0,0,1-1.4-3.4V74.7a1.5,1.5,0,0,1,3,0v9.4a7.57,7.57,0,0,0,.9,1.8,6.21,6.21,0,0,0,4.8,2.8,5.92,5.92,0,0,0,4.9-2.3,6.32,6.32,0,0,0,1.4-2.2V74.8a1.5,1.5,0,1,1,3,0v9.4c0,1.1-.7,2.4-2,4.1A9.73,9.73,0,0,1,554,91.6ZM553.9,77.1a19.85,19.85,0,0,1-19.8-19.8V44.4a17.11,17.11,0,0,1,17.2-17.1h5.2a17.24,17.24,0,0,1,17.2,17.1V57.3A19.78,19.78,0,0,1,553.9,77.1Zm-2.6-46.8a14.25,14.25,0,0,0-14.2,14.2V57.4a16.8,16.8,0,1,0,33.6,0v-13a14.11,14.11,0,0,0-14.2-14.1h-5.2Z"
                transform="translate(-524 -27.3)"
              />
              <circle cx="22.8" cy="24.1" r="1.8" />
              <circle cx="37.4" cy="24.1" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_9") {
    let person_9_val = 0;

    if (state == "person_9_complete") {
      person_9_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_9_val) }}>
        {value => (
          <svg
            className={styles.person_9}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_9_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_9_gradient)">
              <path
                d="M601.2,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-14.4,6.9-22.5,20.4-23.9a1.51,1.51,0,0,1,.4,3h0c-12,1.3-17.8,8.1-17.8,21v21.6A1.45,1.45,0,0,1,601.2,126.3ZM656.5,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-12.6-6-19.7-17.8-21a1.51,1.51,0,0,1,.4-3c13.4,1.5,20.5,9.8,20.5,24v21.5a1.72,1.72,0,0,1-1.6,1.6h0ZM612.2,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,612.2,132.1ZM646.5,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,646.5,132.1ZM629.1,125.8a1.56,1.56,0,0,1-1.3-.8l-11-19.6a1.71,1.71,0,0,1,0-1.4l3.2-6.2-5.9-4.7a1.53,1.53,0,0,1-.4-1.8l4.8-10.7a1.51,1.51,0,0,1,2-.8,1.67,1.67,0,0,1,.9,1.1l9.2,43a1.49,1.49,0,0,1-1.1,1.8,0.48,0.48,0,0,0-.4.1h0Zm-9.3-21.1,5.7,10.2-3.2-15Zm-2.9-13.2,4.3,3.5-1.9-9ZM629.8,125.8a1.54,1.54,0,0,1-1.5-1.5V124l9.2-43a1.65,1.65,0,0,1,1.8-1.2,1.44,1.44,0,0,1,1.1.9l4.8,10.7a1.53,1.53,0,0,1-.4,1.8l-5.9,4.7,3.2,6.2a1.71,1.71,0,0,1,0,1.4l-11,19.6A1.43,1.43,0,0,1,629.8,125.8Zm6.8-25.9-3.2,15,5.7-10.2Zm3-13.9-2,9,4.3-3.5ZM628.9,67.3a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,1,1,.9-2.9,10.42,10.42,0,0,0,6.3,0,1.49,1.49,0,1,1,1,2.8A12,12,0,0,1,628.9,67.3ZM631.4,58.8h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0v4.5h1.1a1.54,1.54,0,0,1,1.5,1.5,1.42,1.42,0,0,1-1.5,1.5h0ZM629,88.5c-5,0-9-2.5-9-5.8V75.2a1.5,1.5,0,0,1,3,0v7.5c0,1.1,2.3,2.8,6,2.8s6-1.7,6-2.8V75.2a1.5,1.5,0,0,1,3,0v7.5C638,86,634,88.5,629,88.5ZM628.8,77A19.85,19.85,0,0,1,609,57.2V44.3a17.11,17.11,0,0,1,17.2-17.1h5.2a17.24,17.24,0,0,1,17.2,17.1V57.2A19.78,19.78,0,0,1,628.8,77Zm-2.6-46.9A14.25,14.25,0,0,0,612,44.3v13a16.8,16.8,0,1,0,33.6,0v-13a14.11,14.11,0,0,0-14.2-14.1ZM609.2,58.6a4.4,4.4,0,1,1,0-8.8h0a1.5,1.5,0,0,1,0,3,1.4,1.4,0,1,0,0,2.8A1.5,1.5,0,0,1,609.2,58.6ZM648.5,58.6a1.5,1.5,0,0,1,0-3,1.4,1.4,0,1,0,0-2.8,1.5,1.5,0,0,1,0-3A4.4,4.4,0,1,1,648.5,58.6ZM612.6,45.8a1.51,1.51,0,0,1-.4-3c7.9-2.1,20.4-7.1,20.3-11.9a1.54,1.54,0,0,1,1.5-1.5h0a1.54,1.54,0,0,1,1.5,1.5c0,3.8-3.8,7.5-11.6,11a102.38,102.38,0,0,1-11,3.9h-0.3ZM631.1,45.3h-0.3a39.19,39.19,0,0,1-10.7-1.7,1.48,1.48,0,0,1-.9-1.9,1.51,1.51,0,0,1,1.8-.9c0.2,0.1,18,5.7,21.6-4.9a1.49,1.49,0,0,1,2.8,1C643.6,42.4,638.6,45.3,631.1,45.3Z"
                transform="translate(-599.7 -27.2)"
              />
              <circle cx="22" cy="24.2" r="1.8" />
              <circle cx="36.6" cy="24.2" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "person_10") {
    let person_10_val = 0;

    if (state == "person_10_complete") {
      person_10_val = 100;
    }

    return (
      <Motion defaultStyle={{ x: 0 }} style={{ x: spring(person_10_val) }}>
        {value => (
          <svg
            className={styles.person_10}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58.21 107.92"
          >
            <defs>
              <linearGradient
                id="person_10_gradient"
                x1="0"
                x2="0"
                y1="1"
                y2="0"
              >
                <stop offset="0%" className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.blue} />
                <stop offset={`${value.x}%`} className={styles.white} />
                <stop offset="100%" className={styles.white} />
              </linearGradient>
            </defs>
            <g fill="url(#person_10_gradient)">
              <path
                d="M701.3,67.3a13.36,13.36,0,0,1-4-.6,1.52,1.52,0,1,1,.9-2.9,9.71,9.71,0,0,0,6.3,0,1.49,1.49,0,1,1,1,2.8A12.34,12.34,0,0,1,701.3,67.3ZM703.8,58.8h-2.6a1.54,1.54,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,3,0v4.5h1.1a1.54,1.54,0,0,1,1.5,1.5,1.47,1.47,0,0,1-1.5,1.5h0ZM673.5,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-14.7,7.2-22.8,21.3-24a1.5,1.5,0,1,1,.2,3c-12.5,1.1-18.5,7.9-18.5,21v21.6a1.54,1.54,0,0,1-1.5,1.5h0ZM728.8,126.3a1.54,1.54,0,0,1-1.5-1.5V103.2c0-12.8-5.9-19.7-18-20.9a1.51,1.51,0,0,1,.4-3c13.6,1.4,20.7,9.7,20.7,23.9v21.6a1.71,1.71,0,0,1-1.6,1.5h0ZM684.5,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.54,1.54,0,0,1,684.5,132.1ZM718.7,132.1a1.54,1.54,0,0,1-1.5-1.5V101.2a1.5,1.5,0,1,1,3,0v29.4A1.47,1.47,0,0,1,718.7,132.1ZM701,91.7a1.69,1.69,0,0,1-1-.3c-2.3-1.9-7.7-6.7-7.7-9.4V74.5a1.5,1.5,0,1,1,3,0V82c0.1,0.9,2.7,3.7,5.7,6.3,3.3-2.6,6.1-5.4,6.3-6.3V74.5a1.5,1.5,0,0,1,3,0V82c0,2.7-5.3,7.1-8.4,9.4A1.61,1.61,0,0,1,701,91.7ZM701.2,77a19.85,19.85,0,0,1-19.8-19.8V44.3a17.26,17.26,0,0,1,17.2-17.2h5.2A17.2,17.2,0,0,1,721,44.3V57.2A19.78,19.78,0,0,1,701.2,77Zm-2.6-46.8a14.25,14.25,0,0,0-14.2,14.2V57.3a16.8,16.8,0,1,0,33.6,0v-13a14.11,14.11,0,0,0-14.2-14.1h-5.2ZM717.5,46.6c-10.7,0-23.7-15.4-24.3-16.1a1.46,1.46,0,0,1,.3-2.1,1.43,1.43,0,0,1,2,.2c4,4.8,15.9,16.7,23.6,14.9a1.49,1.49,0,0,1,.7,2.9h0A16.41,16.41,0,0,1,717.5,46.6ZM683,46.6a1.62,1.62,0,0,1-1.6-1.4,1.54,1.54,0,0,1,1.4-1.6c3.1-.2,7.8-8,10.2-13.4a1.63,1.63,0,0,1,2-.7,1.47,1.47,0,0,1,.7,1.9c-6,14-11.6,15.1-12.7,15.2h0ZM693.2,31.2a1.71,1.71,0,0,1-1.3-.7,8.21,8.21,0,0,1-1.2-4.3c0-4.9,4.7-9,10.5-9s10.5,4,10.5,9a7.87,7.87,0,0,1-1.2,4.2,1.45,1.45,0,0,1-2.1.1,1.53,1.53,0,0,1-.4-1.7,5,5,0,0,0,.8-2.6c0-3.3-3.4-6-7.5-6s-7.5,2.7-7.5,6a5.3,5.3,0,0,0,.8,2.7,1.6,1.6,0,0,1-.5,2.1,1,1,0,0,1-.9.2h0ZM681.5,60.2a4.4,4.4,0,1,1,0-8.8,1.5,1.5,0,0,1,0,3,1.4,1.4,0,1,0,0,2.8A1.5,1.5,0,0,1,681.5,60.2ZM720.8,60.2a1.5,1.5,0,0,1,0-3,1.4,1.4,0,1,0,0-2.8,1.5,1.5,0,0,1,0-3,4.4,4.4,0,1,1,0,8.8h0Z"
                transform="translate(-672 -17.2)"
              />
              <circle cx="22.3" cy="34.1" r="1.8" />
              <circle cx="36.9" cy="34.1" r="1.8" />
            </g>
          </svg>
        )}
      </Motion>
    );
  }

  if (icon === "credit_control" && !shadow) {
    return (
      <svg
        className={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 259 259"
      >
        <path d="M195.12,62.79a4.61,4.61,0,0,1,4.6,4.6V198.2a4.6,4.6,0,0,1-4.6,4.59H64.31a4.6,4.6,0,0,1-4.59-4.59V67.39a4.6,4.6,0,0,1,4.59-4.6H195.12m0-8H64.31a12.6,12.6,0,0,0-12.59,12.6V198.2a12.59,12.59,0,0,0,12.59,12.59H195.12a12.59,12.59,0,0,0,12.6-12.59V67.39a12.6,12.6,0,0,0-12.6-12.6Z" />
        <circle cx="119.04" cy="115.84" r="41" />
        <rect
          x="152.91"
          y="141.05"
          width="20"
          height="48.71"
          transform="translate(-68.91 152.83) rotate(-42.33)"
          stroke="--var(main-font-color)"
        />
        <line
          x1="100.04"
          y1="115.84"
          x2="115.04"
          y2="132.84"
          strokeWidth="8px"
        />
        <line
          x1="138.04"
          y1="96.84"
          x2="115.04"
          y2="132.84"
          strokeWidth="8px"
        />
      </svg>
    );
  }

  if (icon === "credit_control" && shadow) {
    return (
      <div className={styles.shadow}>
        <svg
          className={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 259 259"
        >
          <path d="M195.12,62.79a4.61,4.61,0,0,1,4.6,4.6V198.2a4.6,4.6,0,0,1-4.6,4.59H64.31a4.6,4.6,0,0,1-4.59-4.59V67.39a4.6,4.6,0,0,1,4.59-4.6H195.12m0-8H64.31a12.6,12.6,0,0,0-12.59,12.6V198.2a12.59,12.59,0,0,0,12.59,12.59H195.12a12.59,12.59,0,0,0,12.6-12.59V67.39a12.6,12.6,0,0,0-12.6-12.6Z" />
          <circle cx="119.04" cy="115.84" r="41" />
          <rect
            x="152.91"
            y="141.05"
            width="20"
            height="48.71"
            transform="translate(-68.91 152.83) rotate(-42.33)"
            stroke="--var(main-font-color)"
          />
          <line
            x1="100.04"
            y1="115.84"
            x2="115.04"
            y2="132.84"
            strokeWidth="8px"
          />
          <line
            x1="138.04"
            y1="96.84"
            x2="115.04"
            y2="132.84"
            strokeWidth="8px"
          />
        </svg>
      </div>
    );
  }

  return null;
};

export default Icon;
